import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { RouteInfoService } from 'src/app/services/route-info.service';
import { WholeHist } from 'src/app/services/api-service/hist/whole-hist';
import { SystemCode } from 'src/app/services/api-service/system-code/system-code';
import { Distinct, TrimEnd } from 'src/app/shared/utilities';
import { DxOpt, HistEditOption, RxOpt } from 'src/app/services/api-service/hist/hist-edit-option';
import { Compare, NullOrEmpty, Or, StringEqual } from 'src/app/shared/utilities';
import { MultiPrescriptWrite } from 'src/app/shared/hcr-lib/MultiPrescriptWrite';
import { TreatmentData } from 'src/app/shared/hcr-lib/TreatmentData';
import { EnterRoomDto, HistApi, HrxInitResult } from 'src/app/services/api-service/hist/hist-api';
import { OpdApiService } from 'src/app/services/api-service-dentist/opd/opd-api.service';
import { HelperSourceEnum } from '../enums/helper-source-enum';
import { Rx } from 'src/app/services/api-service/rx/rx';
import { ClinicDataService, DxVersionTag, ValueTextPairBundle } from 'src/app/services/data-service/clinic-data-service';
import { PrescriptionSignMultiWrite } from 'src/app/shared/hcr-lib/PrescriptionSignMultiWrite';
import { RxApi } from 'src/app/services/api-service/rx/rx-api';
import { TmplView } from '../models/tmpl-view';
import { UserCache } from 'src/app/services/user-cache';
import { DispensingTypeEnum, OrderDispensingTypeEnum } from 'src/app/enums/DispensingTypeEnum';
import { OrderTypeEnum } from 'src/app/enums/OrderTypeEnum';
import { LocalStoragesService } from 'src/app/services/local-storages.service';
import { BaseConfig, FunctionEnable } from 'src/app/services/base-config.service';
import { UserConfirmService } from 'src/app/services/user-confirm.service';
import { Hist } from '../models/hist';
import { RegisterConst } from 'src/app/shared/constants/register-const';
import { dentalICD10CM, dentalICD10PCS } from 'src/app/services/api-service/hist/decreeRx';
import { ClinicTypeEnum, M56Code } from 'src/app/enums/ClinicTypeEnum';
import { DateHelper } from 'src/app/shared/helpers/date-helper';

import { RegisterApi } from 'src/app/services/api-service/register/register-api';
import { TherapistScheduleDto } from 'src/app/services/api-service/user/uesrSimpleInfo';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { MemoryCache } from 'src/app/services/memory-cache-service';
import { AuthenticationService } from 'src/app/security/services/authentication.service';
import { OptionTypes } from 'src/app/services/cache-service/options-cached.service';

import { MedicalEnum } from 'src/app/enums/MedicalEnum';
import { HcrService, VisionApiResult } from 'src/app/services/hcr-service.service';

import { SessionService } from 'src/app/services/session.service';
import { IC6_0PresQRCodeBundle } from 'src/app/models/IC6.0PresQRCodeBundle';
import { NullOrEmptyTrim } from '../../shared/utilities';
import { HistOrder } from '../models/hist-order';

import { FileService } from 'src/app/services/api-service/file/file.service';
import * as forge from "node-forge";

import { DebugNotifyService } from 'src/app/services/debug-notify.service';
import { OrderSpecialRuleEnum } from 'src/app/enums/OrderSpecialRuleEnum';
import { TherapistLastRecordDto } from 'src/app/services/api-service/parameters/SCH001Params';
import { ParamGroupEnum } from 'src/app/services/data-service/system-param-cache-define';
import { ParameterApi } from 'src/app/services/api-service/parameters/parameter-api';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';

import { RegisterClinicHistoryDTO } from 'src/app/services/api-service-dentist/register/register-api.model';
import { FocusId } from './declares';
import { P } from '@angular/cdk/keycodes';
type TherapistKey = 'PT' | 'OT' | 'ST' | 'PRT';

const PG_MAP: Record<number, { key: TherapistKey; code: string; flag: string }> = {
  4: { key: 'PT', code: '20', flag: 'isUsingPT' },
  7: { key: 'PRT', code: '22', flag: 'isUsingPRT' },
  9: { key: 'OT', code: '23', flag: 'isUsingOT' },
  10: { key: 'ST', code: '24', flag: 'isUsingST' }
};
export class HistToICCardData {
  MultiPrescriptWrite: MultiPrescriptWrite;
  PrescriptionSignMultiWrite: PrescriptionSignMultiWrite;
  TreatmentData: TreatmentData;
  ErrorMsg: string;
  RegicId: number;
  RegId: number;
  HistoryId?: number;
}
export class CloneJHistToICCardData extends HistToICCardData {
  // 這裡加你子類別自己的欄位
  Hist: Hist;

}
export class HistReady {
  get All() { return this.Dx && this.Rx && this.PE && this.CC };
  get ChiAll() { return this.Dx && this.Rx && this.ChiAsk };
  get PharAll() { return this.Dx && this.Rx };
  Dx: boolean = false;
  Rx: boolean = false;
  CC: boolean = false;
  PE: boolean = false;
  ChiAsk: boolean = false;
}
export class RxCodeSurs {
  Code: string;
  Surs: string[];
  IsRs: boolean = false
}
export class RxCodeSPTXs {
  Code: string;
  SPTXs: string[];
  IsRs: boolean = false
}
export class PrintResult {
  CompleteMode: 'Next' | 'List' | 'Cancel' | 'DontPrint' | 'DontPrintAndNext';
  IsPrintPrescription: boolean; // 列印處方箋1
  IsPrintDetail: boolean;// 明細收據2
  IsPrintWay: boolean;// 服法收據
  IsPrintExam: boolean; //院內檢驗單
  IsPrintDispPrescription: boolean; // 列印交付處方箋5
  IsPrintDispExam: boolean; //交付檢驗單
  IsPrintDrugBag: boolean; // 列印藥袋
  IsPrintMedRecord: boolean; // 列印病歷單
  IsPrintCtrDrugs: boolean;//列印管制藥品處方箋
  IsPrintInjectForm: boolean; //列印注射單
  //IsPrintCheck:boolean;
}

@Injectable({
  providedIn: 'root'
})
export class HistService {

  constructor(public histApi: HistApi,
    private clinicData: ClinicDataService,
    private localStorage: LocalStoragesService,
    private rxApi: RxApi,
    private opdApi: OpdApiService,
    private userConfirmService: UserConfirmService,
    private sessionService: SessionService,
    private regApi: RegisterApi,
    private hcrService: HcrService,
    private router: Router,
    private routeInfo: RouteInfoService,
    private fileService: FileService,
    private auth: AuthenticationService,
    private debugNotify: DebugNotifyService,
    private paramApi: ParameterApi,
    private notification: EasyNotificationService,


  ) {
    this.auth.logoutEvent.subscribe(a => {
      this.ICD10CMs = null;
      this.ICD10PCSs = null;
      this.currentHist = null;
      this.histForRegChange = null;
      this.cache = new MemoryCache();
      this.surClear();
      this.sptxClear();
      this.rahbitUserDate = null;
      this.rahbitUser = null;
      this.editOption = null;
      this.clinicHistoryies = [];
      this.clinicHistoryByToothPos = {};
      this.currentGridStdCodes = [];
      this.currentGridEntries = [];
      this.currentSameTreatmentHistories = [];
      this.currentSameTreatmentDiagCodes = [];
      this.currentSameTreatmentToothPositions = [];
      this.currentDentalPerioIntegratedCareCase = '';
      this.currentManualUnavailableToothMarkers = [];
    })
  }


  /** 門診庫存不足提醒「此醫令本日不再提醒」localStorage key（per RxCode，跨日自動失效） */
  private readonly opdLowStockMuteKey = 'OpdLowStockMuteRxCodes';

  /** 取得今天被靜音的醫令 RxCode 清單（儲存日期非今天則視為空） */
  private getOpdLowStockMutedRxCodes(): string[] {
    var saved = this.localStorage.getItem(this.opdLowStockMuteKey);
    if (saved && saved.date === new Date().toDateString() && Array.isArray(saved.codes)) {
      return saved.codes;
    }
    return [];
  }

  /** 此醫令今天是否已勾「此醫令本日不再提醒」 */
  isOpdLowStockRxMutedToday(rxCode: string): boolean {
    return this.getOpdLowStockMutedRxCodes().includes(rxCode);
  }

  /** 將指定醫令加入今天的靜音清單（當天有效，跨日自動失效） */
  addOpdLowStockMuteRxToday(rxCodes: string[]): void {
    var codes = this.getOpdLowStockMutedRxCodes();
    for (const c of rxCodes) {
      if (!codes.includes(c)) {
        codes.push(c);
      }
    }
    this.localStorage.setItem(this.opdLowStockMuteKey, { date: new Date().toDateString(), codes: codes });
  }

  private cache: MemoryCache = new MemoryCache();

  public ICD10CMs: dentalICD10CM[];
  public ICD10PCSs: dentalICD10PCS[];

  isHist: boolean = false;
  public currentHist: WholeHist;
  public currentEnterRoom: EnterRoomDto;
  public histForRegChange: WholeHist;

  /** 當前患者合併院內、IC 與雲端後的歷史處置紀錄（供牙科處置檢核使用） */
  public clinicHistoryies: RegisterClinicHistoryDTO[] = [];
  /** 以牙位為 key 的歷史處置映射（同一牙位可能有多筆） */
  public clinicHistoryByToothPos: { [toothPos: string]: RegisterClinicHistoryDTO[] } = {};

  /** 當前 order-grid-dental 中已存在的 StdCode 清單（由 grid 即時更新，供 helper 規則檢核使用） */
  public currentGridStdCodes: string[] = [];

  /** 當前 grid 中每列的處置、牙位、牙面、Id 與原始列號（供規則及牙圖即時使用） */
  public currentGridEntries: { StdCode: string; ToothPos: string; Way?: string; Id?: number; RowIndex?: number }[] = [];
  public currentSameTreatmentHistories: WholeHist[] = [];
  public currentSameTreatmentDiagCodes: string[] = [];
  public currentSameTreatmentToothPositions: string[] = [];
  public currentDentalPerioIntegratedCareCase: string = '';
  /** 當次牙歷圖手動標記為缺牙、已拔除、橋體或植體的牙位，以及牙圖資訊更新時間。 */
  public currentManualUnavailableToothMarkers: { ToothPos: string; EditTime?: Date | string }[] = [];

  /** 牙科規則檢核用歷史：同一筆掛號改以當前 grid 狀態為準，不再拿已儲存舊列比對。 */
  public getDentalRuleClinicHistoriesForCurrentEdit(): RegisterClinicHistoryDTO[] {
    const currentRegId = Number(this.currentHist?.Register?.Id || 0);
    const gridHRxIdSet = new Set<number>();
    for (const entry of this.currentGridEntries || []) {
      if (entry.Id) gridHRxIdSet.add(entry.Id);
    }

    const histories = this.getDentalHistoriesOnOrBeforeCurrentVisit(this.clinicHistoryies).filter(h => {
      if (currentRegId && Number(h.RegId) === currentRegId) return false;
      if (!currentRegId && gridHRxIdSet.has(h.HRxId)) return false;
      if (this.isSameCurrentDentalCourse(h)) return false;
      return true;
    });

    const visitDate = this.toDentalDay(this.currentHist?.Register?.RegDate);
    const manualMarkers = new Map<string, Date | string>();
    for (const marker of this.currentManualUnavailableToothMarkers || []) {
      if (marker?.ToothPos) manualMarkers.set(marker.ToothPos, marker.EditTime);
    }
    const manualUnavailableHistories = Array.from(manualMarkers.entries())
      .map(([toothPos, editTime]) => {
        const validEditDate = this.toDentalDay(editTime) || visitDate;
        if (!validEditDate || !visitDate || validEditDate.getTime() > visitDate.getTime()) {
          return null;
        }
        const rocDate = `${validEditDate.getFullYear() - 1911}/${String(validEditDate.getMonth() + 1).padStart(2, '0')}/${String(validEditDate.getDate()).padStart(2, '0')}`;
        return new RegisterClinicHistoryDTO({
          RegId: 0,
          HistId: 0,
          HRxId: 0,
          RxCode: '牙圖手動標記',
          StdCode: '牙圖手動標記',
          RxName: '牙圖手動標記',
          RxType: 0,
          Sort: 0,
          RegDate: rocDate,
          ToothPos: toothPos,
          Way: '',
          Isqno: '',
          Nhictp: this.currentHist?.Register?.Nhictp || '',
          DoctorName: '',
          ClinicCode: '',
          ClinicNhiCode: '',
          ClinicName: '',
          HistorySource: 'internal',
          IsLocal: true
        });
      })
      .filter((history): history is RegisterClinicHistoryDTO => !!history);

    return histories.concat(manualUnavailableHistories);
  }

  /** 取得看診日當天以前的牙科歷史；清單本身仍保留完整資料。 */
  public getDentalHistoriesOnOrBeforeCurrentVisit(histories: RegisterClinicHistoryDTO[] = this.clinicHistoryies): RegisterClinicHistoryDTO[] {
    const visitDate = this.toDentalDay(this.currentHist?.Register?.RegDate);
    if (!visitDate) return [];

    return (histories || []).filter(history => {
      const historyDate = this.toDentalDay(history?.RegDate);
      return !!historyDate && historyDate.getTime() <= visitDate.getTime();
    });
  }

  private isSameCurrentDentalCourse(history: RegisterClinicHistoryDTO): boolean {
    const currentDate = this.toDentalDay(this.currentHist?.Register?.RegDate);
    const historyDate = this.toDentalDay(history?.RegDate);
    if (!currentDate || !historyDate || currentDate.getTime() !== historyDate.getTime()) return false;

    const currentCardType = this.normalizeDentalIdentity(this.currentHist?.Register?.Nhictp);
    const currentCardSequence = this.normalizeDentalIdentity(
      this.currentHist?.Register?.Icno || this.currentHist?.Hist?.Isqno
    );
    const historyCardType = this.normalizeDentalIdentity(history?.Nhictp);
    const historyCardSequence = this.normalizeDentalIdentity(history?.Isqno);
    if (!currentCardType || !currentCardSequence ||
      currentCardType !== historyCardType || currentCardSequence !== historyCardSequence) {
      return false;
    }

    if (currentCardType !== 'AB') return true;

    const currentIsqnoExt = this.normalizeDentalIdentity(this.currentHist?.Register?.IsqnoExt);
    const historyIsqnoExt = this.normalizeDentalIdentity(history?.IsqnoExt);
    const currentStartDate = this.getDentalDateKey(this.currentHist?.Hist?.DateStart);
    const historyStartDate = this.getDentalDateKey(history?.TreatmentStartDate);
    if (currentIsqnoExt && historyIsqnoExt && currentIsqnoExt !== historyIsqnoExt) return false;
    if (currentStartDate && historyStartDate && currentStartDate !== historyStartDate) return false;

    // 缺少兩邊可比對的療程欄位時，保守保留，避免誤排除不同 AB 療程。
    return !!((currentIsqnoExt && historyIsqnoExt) || (currentStartDate && historyStartDate));
  }

  private normalizeDentalIdentity(value: any): string {
    return String(value || '').trim().toUpperCase();
  }

  private getDentalDateKey(value: any): string {
    const date = this.toDentalDay(value);
    return date
      ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
      : '';
  }

  private toDentalDay(value: any): Date | null {
    if (value instanceof Date) {
      if (isNaN(value.getTime())) return null;
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    const raw = String(value || '').trim();
    if (!raw) return null;
    const createDate = (year: number, month: number, day: number): Date | null => {
      const date = new Date(year, month - 1, day);
      return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
        ? date
        : null;
    };

    const rocSeparated = raw.match(/^(\d{1,3})[-\/](\d{1,2})[-\/](\d{1,2})/);
    if (rocSeparated) {
      return createDate(Number(rocSeparated[1]) + 1911, Number(rocSeparated[2]), Number(rocSeparated[3]));
    }
    const gregorianSeparated = raw.match(/^(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})/);
    if (gregorianSeparated) {
      return createDate(Number(gregorianSeparated[1]), Number(gregorianSeparated[2]), Number(gregorianSeparated[3]));
    }
    const rocCompact = raw.match(/^(\d{3})(\d{2})(\d{2})/);
    if (rocCompact) {
      return createDate(Number(rocCompact[1]) + 1911, Number(rocCompact[2]), Number(rocCompact[3]));
    }
    const parsed = new Date(raw);
    return isNaN(parsed.getTime()) ? null : new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
  }

  /** grid 規則檢核完成時觸發，供 record-dental 病歷檢查面板訂閱 */
  public ruleCheckTrigger$ = new Subject<void>();
  /** order-grid 牙位或牙面變更時觸發，供牙圖即時重建 */
  public dentalGridChanged$ = new Subject<void>();

  /** 從 ClinicHistoryies 建立以牙位為 key 的映射 */
  public buildClinicHistoryByToothPos(histories: RegisterClinicHistoryDTO[]): void {
    this.clinicHistoryies = histories || [];
    this.clinicHistoryByToothPos = {};
    this.clinicHistoryies.forEach(h => {
      const positions = h.ToothPos ? h.ToothPos.split(',').map(p => p.trim()).filter(p => p) : ['_NO_POS_'];
      positions.forEach(pos => {
        if (!this.clinicHistoryByToothPos[pos]) {
          this.clinicHistoryByToothPos[pos] = [];
        }
        this.clinicHistoryByToothPos[pos].push(h);
      });
    });
    console.log('🦷 [HistService] clinicHistoryies 筆數:', this.clinicHistoryies.length);
    console.log('🦷 [HistService] clinicHistoryByToothPos:', this.clinicHistoryByToothPos);
  }
  public onHistLoaded: EventEmitter<WholeHist> = new EventEmitter<WholeHist>()
  public onHistLoaded2: EventEmitter<EnterRoomDto> = new EventEmitter<EnterRoomDto>()
  public onHistReady: EventEmitter<HistReady> = new EventEmitter<HistReady>()
  public onHistFetch: EventEmitter<(a: WholeHist) => void> = new EventEmitter<(a: WholeHist) => void>()
  public onTmplViewEmitInsert: EventEmitter<TmplView> = new EventEmitter<TmplView>();
  public onGetVT: EventEmitter<(vt) => void> = new EventEmitter();
  /** 通知HistView有地方呼叫進行複製行為 */
  public onCopyFomView: EventEmitter<void> = new EventEmitter()

  /**
   * 事件總線：當 order-grid 有變動（例如 CalPrice 更新）時發出，用以通知其他元件（如 rating-price）重新計算/刷新
   */
  public orderGridChanged$: Subject<void> = new Subject<void>();

  public currentHistSurs: RxCodeSurs[] = [];
  public delCodes: RxCodeSurs[] = [];
  public currentHistSPTXs: RxCodeSPTXs[] = [];
  public delSPTXCodes: RxCodeSPTXs[] = [];
  private rahbitUserDate: Date;
  public rahbitUser: TherapistScheduleDto[];
  private mainSetCode: string = '';
  private mainSetName: string = '';



  histUIState: HistReady = new HistReady()
  editOption: HistEditOption;
  hrxInitResultsTemp: HrxInitResult[] = [];
  chosenTherapist: TherapistLastRecordDto;
  tempTherapist: TherapistLastRecordDto;
  isallowSaving: boolean = false;
  isUsingPT = false;
  isUsingOT = false;
  isUsingST = false;
  isUsingPRT = false;
  /** 醫令類別與可用調劑選項與預設值判斷, 沒列出的歸屬在UI上會被鎖住 */
  public dispCodeMap = [{
    types: [
      OrderTypeEnum.T2_OralDrugFee,
      OrderTypeEnum.T3_ExtDrugFee,
      OrderTypeEnum.T12_SpecialMaterialFee],
    dispCode: [
      OrderDispensingTypeEnum.T0_Clinic,
      OrderDispensingTypeEnum.T1_OutOfClinic],
    default: (order: RxOpt) => {
      var hasPharmacist = UserCache.getLoginUser().Clinic.HasPharmacist;
      var ishomecare = UserCache.getLoginUser().Clinic.TypeIsHomeCare;
      var IsrecoveryHome = UserCache.getLoginUser().Clinic.TypeIsRecoveryHome;
      var intPharId = false;
      if (hasPharmacist) {
        intPharId = this.sessionService.getPhar() > 0;
      }
      //康家居護的特材為自調
      if (order.Type == OrderTypeEnum.T12_SpecialMaterialFee && (ishomecare || IsrecoveryHome)) {
        return OrderDispensingTypeEnum.T0_Clinic;
      }
      else {
        //中醫預設為自行調劑
        return (intPharId || this.IsChineseMode) ? OrderDispensingTypeEnum.T0_Clinic : OrderDispensingTypeEnum.T1_OutOfClinic;
      }
    }
  }, {
    // 只可自調/交付的
    types: [OrderTypeEnum.T4_InjectionDrugFee,// 針劑除胰島素相關的 會有委外 其他多為自調
    OrderTypeEnum.T8_RehabilitationFee,
    OrderTypeEnum.T800_OwnSpecial
    ],
    dispCode: [
      OrderDispensingTypeEnum.T0_Clinic,
      OrderDispensingTypeEnum.T1_OutOfClinic],
    default: (order: RxOpt) => {
      return OrderDispensingTypeEnum.T0_Clinic;
    }
  }, {
    types: [
      OrderTypeEnum.T6_Lab,
      OrderTypeEnum.T7_XRay
    ],
    dispCode: [
      OrderDispensingTypeEnum.T0_Clinic,
      OrderDispensingTypeEnum.T1_OutOfClinic,
      OrderDispensingTypeEnum.T2_RefLabHosp,
      OrderDispensingTypeEnum.T3_RefLabClinic,
      OrderDispensingTypeEnum.T4_LabHosp,
      OrderDispensingTypeEnum.T5_LabHospClinic
    ],
    default: (order: RxOpt) => {
      if (order.SPRule == 6) {
        return OrderDispensingTypeEnum.T4_LabHosp;
      }
      else if (order.SPRule == 7) {
        return OrderDispensingTypeEnum.T4_LabHosp;
      }
      else if (this.currentHist?.Register?.INote == RegisterConst.INote_代檢 && this.currentHist?.Register?.ICode == RegisterConst.ICode_009_Other) {
        return OrderDispensingTypeEnum.T5_LabHospClinic;
      }
      else {
        return OrderDispensingTypeEnum.T0_Clinic
      }
    }
  }];
  public emitTmplViewInsert(tmpl: TmplView) {
    this.onTmplViewEmitInsert.emit(tmpl);
  }
  //public onHistFinish: EventEmitter<WholeHist> = new EventEmitter<WholeHist>()
  public async loadHist(regId: number, loadNext: boolean = false, patId: number = 0) {
    this.histUIState = new HistReady();
    if (FunctionEnable.EnableClientAdvCache && !UserCache.getLoginUser().Clinic.TypeIsDental) {
      if (this.IsPharmacyMode) {
        var data = await this.histApi.enterPharRoom(regId, loadNext, patId)
      } else {
        var data = await this.histApi.enterRoom(regId, loadNext, patId)
      }

      this.currentHist = data.hist
      this.currentEnterRoom = data;
      //先抓
      await this.getHrxInitData(data.hist.Hist.HRxs)
      this.onHistLoaded2.emit(data);
    } else {
      this.currentHist = await this.histApi.getWholeHist({ regId: regId });
      this.onHistLoaded.emit(this.currentHist);
    }
  }


  async getHrxInitData(codes: HistOrder[]) {
    // 不在temp裡的再抓
    codes = codes.filter(c => !this.hrxInitResultsTemp.map(x => x.Rx.RxCode).some(x => x == c.RxCode))

    let psa = this.currentHist.Patient.PaySysA;
    let dateQuery = this.currentHist.Register.RegDate;
    if (codes.length > 0) {
      // 初始資料
      var initDataRet = await this.histApi.GetHrxInit({
        codes: codes.map(x => x.RxCode),
        types: Distinct(codes.map(x => x.RxType)),
        dateQuery: dateQuery,
        paySysA: psa,
        cusTp: this.currentHist.Register.SameTreat,
        //weight:this.histService.currentHist.VitalSign.Weight,
        specialType: this.currentHist.Register.SameTreat == RegisterConst.SameTreat_F_在宅計畫 ? '在宅' : '',
      });
      this.hrxInitResultsTemp = this.hrxInitResultsTemp.concat(...initDataRet);
    }

    codes.forEach(x => {
      if (!x.Rx) {
        x.Rx = this.hrxInitResultsTemp.find(y => y.Rx?.RxCode == x.RxCode)?.Rx;
      }
    })
    return this.hrxInitResultsTemp;
  }
  public async fetchHist() {
    var newHist = await new Promise<WholeHist>((rs, rj) => {
      this.onHistFetch.emit(rs);
    })
    this.currentHist = newHist;
    return this.currentHist;
  }

  public async loadHistForRegChange(regId: number) {
    this.histForRegChange = await this.histApi.getWholeHist({ regId: regId });
  }

  public async FinishHist() {
    this.onHistLoaded.emit(this.currentHist);
  }

  public UIReset() {
    this.histUIState = new HistReady()
    this.onHistReady.emit(this.histUIState);
  }
  public UIReady(tp: 'Dx' | 'Rx' | 'CC' | 'PE' | HelperSourceEnum) {
    switch (tp) {
      case 'Dx': this.histUIState.Dx = true; break;
      case 'Rx': this.histUIState.Rx = true; break;
      case 'CC': this.histUIState.CC = true; break;
      case 'PE': this.histUIState.PE = true; break;
    }
    if (this.histUIState[tp] == false) {
      this.histUIState[tp] = true;
    }
    console.log(tp, 'ready');
    this.onHistReady.emit(this.histUIState);
  }
  public UIUnReady(tp: 'Dx' | 'Rx' | 'CC' | 'PE' | HelperSourceEnum) {
    switch (tp) {
      case 'Dx': this.histUIState.Dx = false; break;
      case 'Rx': this.histUIState.Rx = false; break;
      case 'CC': this.histUIState.CC = false; break;
      case 'PE': this.histUIState.PE = false; break;
    }
    console.log(tp, 'lock', this.histUIState);
    this.onHistReady.emit(this.histUIState);
  }

  public ICD10Version(regDate: Date = null): DxVersionTag {
    var verDate = regDate ? DateHelper.createDate(regDate) : DateHelper.createDate(new Date().setHours(0, 0, 0, 0));
    var icd102023StartDate = this.EditOptions.opdParams.DiagnosisICD102023StartDate ? DateHelper.createDate(this.EditOptions.opdParams.DiagnosisICD102023StartDate) : null;
    var version: DxVersionTag = (this.EditOptions.opdParams.DiagnosisICD102023ForceUse || (icd102023StartDate != null && verDate >= icd102023StartDate)) ? '2023' : '2014';
    return version;
  }

  public ICD10Enable(regDate: Date = null): boolean {
    return this.ICD10Version(regDate) == '2023';
  }

  //#region 參數設定相關
  /** ValueTextPair 轉 SystemCode：extension=Name1, ext2=Name2, ext3=Attribute, ext4=Name3
   *  註：pad-data-provider.getOriginItem 內的 findSystemCode 有相同的轉換，兩邊需一起維護 */
  toValueTextPair(codes: ValueTextPairBundle, codeType: string, filter?: (c: ValueTextPair) => boolean) {
    if (!filter) {
      return codes[codeType].map(x => new SystemCode(x.value, x.text, x.extension, x.ext2, x.ext3, x.ext4));
    } else {
      return codes[codeType].filter(x => filter(x)).map(x => new SystemCode(x.value, x.text, x.extension, x.ext2, x.ext3, x.ext4));
    }
  }
  async Init() {
    this.editOption = new HistEditOption()
    var codes = await this.clinicData.getSystemCodes(['E0010', 'E0020', 'E0030', 'C0160', 'C0200', 'C0300', 'C0360', 'C0070', 'C0220', 'C0201'])
    var enums = await this.clinicData.getEnum(['TimeSec', 'Sex', 'SpcIdentity']);
    // var toValueTextPair = (codeType:string,filter?:(c:ValueTextPair)=>boolean)=>{
    //   if(!filter){
    //     return codes[codeType].map(x=> new SystemCode(x.value,x.text,x.extension,x.ext2,x.ext3));
    //   }else{
    //     return codes[codeType].filter(x=>filter(x)).map(x=> new SystemCode(x.value,x.text,x.extension,x.ext2,x.ext3));
    //   }
    // }
    this.editOption.cc = this.toValueTextPair(codes, 'E0020');
    this.editOption.pe = this.toValueTextPair(codes, 'E0030');
    this.editOption.way = this.toValueTextPair(codes, 'C0160');
    this.editOption.part = this.toValueTextPair(codes, 'C0200');
    this.editOption.chiPart = this.toValueTextPair(codes, 'C0201');
    this.editOption.chiProcess = this.toValueTextPair(codes, 'C0300');
    this.editOption.chiForm = this.toValueTextPair(codes, 'C0360');
    // 調劑選項 "" 跟 "1"為醫令調劑
    if (this.IsPharmacyMode) {
      this.editOption.dispensing = codes['C0070'].filter(x => x.ext3 == '3');
    } else {
      this.editOption.dispensing = codes['C0070'].filter(x => x.ext3 == '' || x.ext3 == '1');
    }
    this.editOption.remarks = codes['C0220'].filter(x => x.extension == 'Oral');
    this.editOption.hrxRemarks = codes['C0220'].filter(x => x.extension == 'Hrx_Remark' || x.extension == '');

    var hst001 = await this.clinicData.getParam('HST001');
    var hst002 = await this.clinicData.getParam('HST002');
    var opd002 = await this.clinicData.getParam('OPD002');
    var pay001 = await this.clinicData.getParam('PAY001');
    var stk001 = await this.clinicData.getParam('STK001');
    var chi001 = await this.clinicData.getParam('CHI001');
    this.editOption.histParams = hst001;
    this.editOption.opdParams = opd002;
    this.editOption.hist2Params = hst002;
    this.editOption.stkParams = stk001;
    this.editOption.chiParams = chi001;
    this.editOption.isShowPricingWindow = !pay001.ChargeCounter
    this.editOption.isAlertPaid = pay001.ChargeFlow != "before";
    this.editOption.p15 = await this.clinicData.getGPPara(15);
    this.editOption.p135 = await this.clinicData.getGPPara(135);
    this.editOption.p253 = await this.clinicData.getGPPara(253);
    this.editOption.p255 = await this.clinicData.getGPPara(255);
    this.editOption.p289 = await this.clinicData.getGPPara(289);
    this.editOption.p37 = await this.clinicData.getGPPara(37);
    this.editOption.p79 = await this.clinicData.getGPPara(79);
    this.editOption.sex = enums['Sex'];

    this.editOption.executor = await this.clinicData.GetExecutor()
    this.editOption.doctor = (await this.clinicData.getOptions(OptionTypes.Doctors)).map(x => {
      return {
        value: x.value,
        text: x.text,
        extension: x.ext2 // MedLicense
      }
    })
    this.editOption.dosage = await this.clinicData.GetDosages();
    var phars = await this.clinicData.getOptions(OptionTypes.Pharmacist);
    this.editOption.defaultSelfDispensing = (UserCache.getLoginUser().Clinic.MedDivSdate && phars.length > 0) ? '1' : '0'
  }

  // StartUp 載入完成後才會載入Component,所以大概會有資料
  get EditOptions() {
    return this.editOption
  }
  get IsEnableFrontValidation() {
    return this.EditOptions.histParams.IsEnableFrontValidation
  }
  get IsShowPricingWindow() {
    return this.EditOptions.isShowPricingWindow;
  }
  get IsChineseMode() {
    // 這邊要改為判斷Clinic相關設定 或者是科別?
    return UserCache.IsChineseMode();
  }
  get IsPharmacyMode() {
    return UserCache.IsPharmacyMode();
  }
  get IsDentistMode() {
    // 這邊要改為判斷Clinic相關設定 或者是科別?
    return UserCache.IsDentistMode();
  }
  get CanLoginPromptInsufficientInventory() {
    const user = UserCache.getLoginUser();
    return user.IsSuper || user.CanLoginPromptInsufficientInventory;
  }
  get EnableStockSystem() {
    return this.EditOptions.stkParams.EnableStockSystem;
  }
  get ClinicId() {
    return UserCache.getLoginClinicId();
  }
  /** 進入門診畫面要Focus的項目 */
  get FirstFocus(): FocusId {
    if (UserCache.IsPharmacyMode()) {
      return FocusId.PharRegister;
    }
    var focusOpt = this.EditOptions.p15;
    switch (focusOpt) {
      case '1':
        return FocusId.Diag;
      case '2':
        return FocusId.Order;
      //case '3':
      //  return FocusId.CC;
      //case '4':
      //  return FocusId.PE;
      case '5':
        return FocusId.Diag;
      default:
        return this.IsChineseMode ? FocusId.ChiAsk : FocusId.CC
    }
    /*
    return focusOpt == '1' ? FocusId.Diag :
      focusOpt == '2' ? FocusId.Order :
        this.IsChineseMode?FocusId.ChiAsk:FocusId.CC;
    */
  }
  get TotalDiagnosis(): number {
    // 診斷數目
    return this.EditOptions.opdParams.TotalDiagnosis;
  }
  get SentenceWordDelimiter(): string {
    // 文字分隔符號
    return this.EditOptions.opdParams.SentenceWordDelimiter || ' ';
  }
  get IsEnableDiabetes() {
    return this.EditOptions.histParams.IsEnableDiabetes;
  }
  get MainSetCode() {
    return this.mainSetCode;
  }
  get MainSetName() {
    return this.mainSetName;
  }
  get MainSetCodeName() {
    return this.mainSetCode ? '組合: ' + this.mainSetCode + ' ' + this.mainSetName : '';
  }
  set MainSetCode(code: string) {
    this.mainSetCode = code;
  }
  set MainSetName(name: string) {
    this.mainSetName = name;
  }

  //#region Promise寫法
  async getCCOptions(codeName?: string, sortByMatch: boolean = false): Promise<SystemCode[]> {
    console.log("📢[hist.service.ts:597]: codeName: ", codeName);
    var cc: SystemCode[] = []
    if (FunctionEnable.EnableClientAdvCache) {
      var codes = await this.clinicData.getSystemCodes(['E0020', 'E0010'])
      cc = [...this.toValueTextPair(codes, 'E0020'), ...this.toValueTextPair(codes, 'E0010')];
      //cc =this.editOption.cc;
    } else {
      const editopt = await this.histApi.getEditOptions();
      cc = editopt.cc;
    }

    var emptyCode = NullOrEmpty(codeName);
    if (emptyCode) {
      return cc;
    }
    // 不排序(按照server端下來的Code順序)
    if (sortByMatch == false) {
      return cc.filter(c => this.containWithoutCase(c.Code, codeName) || this.containWithoutCase(c.Name, codeName));
    } else {
      // 比較 文字位置出現在比較前面的先,同樣順序者 文字短的先
      var indexOfWhoutCase = (s: string, s2: string) => {
        return s.toLocaleLowerCase().indexOf(s2.toLocaleLowerCase());
      }
      var codeMatch = cc.filter(c => this.containWithoutCase(c.Code, codeName)).sort((a, b) => Compare(indexOfWhoutCase(a.Code, codeName), indexOfWhoutCase(b.Code, codeName)) || Compare(a.Code.length, b.Code.length));
      var nameMatch = cc.filter(c => !codeMatch.some(x => x.Code.toLowerCase() == c.Code.toLowerCase()) && this.containWithoutCase(c.Name, codeName)).sort((a, b) => Compare(indexOfWhoutCase(a.Name, codeName), indexOfWhoutCase(b.Name, codeName)));
      //Task 17972: X7021 輸入主訴,或是各種代碼時候跳出來的快速選項上的選項沒有照英文跟號碼排序
      // 符合Code時,依Code作排序
      codeMatch.sort((a, b) => {
        // 檢查是否以輸入字元開頭
        const searchStr = codeName.toLowerCase();
        const aStartsWith = a.Code.toLowerCase().startsWith(searchStr);
        const bStartsWith = b.Code.toLowerCase().startsWith(searchStr);
        // 如果一個符合，另一個不符合，符合的排前面
        if (aStartsWith && !bStartsWith) return -1;
        if (!aStartsWith && bStartsWith) return 1;
        // 如果兩者狀態相同（都符合或都不符合），則使用自然排序
        return a.Code.localeCompare(b.Code, undefined, { numeric: true });
      });

      return codeMatch.concat(nameMatch);
    }

    // let query = 'getCCOptions?name=' + codeName;
    // query = this.queryAddCount(query, count);
    // return this.api.get(query);
  }
  /** 特記(西醫)打字查詢：查 E0190 + E0010 共用，排序邏輯比照 getCCOptions */
  async getSpecialNoteOptions(codeName?: string, sortByMatch: boolean = false): Promise<SystemCode[]> {
    var codes = await this.clinicData.getSystemCodes(['E0190', 'E0010']);
    var note: SystemCode[] = [...this.toValueTextPair(codes, 'E0190'), ...this.toValueTextPair(codes, 'E0010')];

    var emptyCode = NullOrEmpty(codeName);
    if (emptyCode) {
      return note;
    }
    // 不排序(按照server端下來的Code順序)
    if (sortByMatch == false) {
      return note.filter(c => this.containWithoutCase(c.Code, codeName) || this.containWithoutCase(c.Name, codeName));
    } else {
      var indexOfWhoutCase = (s: string, s2: string) => {
        return s.toLocaleLowerCase().indexOf(s2.toLocaleLowerCase());
      }
      var codeMatch = note.filter(c => this.containWithoutCase(c.Code, codeName)).sort((a, b) => Compare(indexOfWhoutCase(a.Code, codeName), indexOfWhoutCase(b.Code, codeName)) || Compare(a.Code.length, b.Code.length));
      var nameMatch = note.filter(c => !codeMatch.some(x => x.Code.toLowerCase() == c.Code.toLowerCase()) && this.containWithoutCase(c.Name, codeName)).sort((a, b) => Compare(indexOfWhoutCase(a.Name, codeName), indexOfWhoutCase(b.Name, codeName)));
      // 符合Code時,依Code作排序
      codeMatch.sort((a, b) =>
        a.Code.localeCompare(b.Code, undefined, {
          numeric: true,
          sensitivity: 'base'
        })
      );
      return codeMatch.concat(nameMatch);
    }
  }
  containWithoutCase(text: string, search: string) {
    return text.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  }
  async getPEOptions(codeName?: string, sortByMatch: boolean = false): Promise<SystemCode[]> {
    // console.log('getPEOptions');
    var pe: SystemCode[] = []
    if (FunctionEnable.EnableClientAdvCache) {
      var codes = await this.clinicData.getSystemCodes(['E0010', 'E0030'])
      pe = [...this.toValueTextPair(codes, 'E0030'), ...this.toValueTextPair(codes, 'E0010')];
      //pe =this.editOption.pe;
    } else {
      const editopt = await this.histApi.getEditOptions();
      pe = editopt.pe;
    }

    var emptyCode = NullOrEmpty(codeName);
    if (emptyCode) {
      return pe;
    }
    // 不排序(按照server端下來的Code順序)
    if (sortByMatch == false) {
      return pe.filter(c => this.containWithoutCase(c.Code, codeName) || this.containWithoutCase(c.Name, codeName));
    } else {
      var codeMatch = pe.filter(c => this.containWithoutCase(c.Code, codeName)).sort((a, b) => Compare(a.Code.indexOf(codeName), b.Code.indexOf(codeName)));
      var nameMatch = pe.filter(c => !codeMatch.some(x => x.Code.toLowerCase() == c.Code.toLowerCase()) && this.containWithoutCase(c.Name, codeName)).sort((a, b) => Compare(a.Name.indexOf(codeName), b.Name.indexOf(codeName)));

      // Task 17972: X7021 符合Code時,依Code作排序
      codeMatch.sort((a, b) => {
        const searchStr = codeName.toLowerCase();
        const aStartsWith = a.Code.toLowerCase().startsWith(searchStr);
        const bStartsWith = b.Code.toLowerCase().startsWith(searchStr);
        if (aStartsWith && !bStartsWith) return -1;
        if (!aStartsWith && bStartsWith) return 1;
        return a.Code.localeCompare(b.Code, undefined, { numeric: true });
      });
      return codeMatch.concat(nameMatch);
    }
    // let query = 'getPEOptions?name=' + codeName;
    // query = this.queryAddCount(query, count);
    // return this.api.get(query);
  }

  /** 比較邏輯：Code:從頭 || Short:從頭 || 名稱:包含 */
  async getDiagList(code: string, sortByMatch: boolean = false, diagVersion: DxVersionTag = ''): Promise<DxOpt[]> {
    //此方法很多地方都有使用，若傳入diagVersion是空字串，則用當天日期判斷取得的診斷資料
    if (!diagVersion) {
      diagVersion = this.ICD10Version();
    }

    //console.log('getDiagList');
    var dx = await this.clinicData.GetDxOption(diagVersion);
    var emptyCode = NullOrEmpty(code);
    if (emptyCode) {
      return dx;
    }
    code = code.toLowerCase();
    // 不排序(按照server端下來的Code順序)
    if (sortByMatch == false) {
      return dx.filter(c => emptyCode ? true
        : c.Code?.toLowerCase().startsWith(code)
        || c.ICD9?.toLowerCase().startsWith(code)
        || c.ApplyCode?.toLowerCase().startsWith(code)
        || c.Short?.toLowerCase().startsWith(code)
        || c.ShortNo?.toLowerCase().indexOf(code) >= 0
        || c.CName?.toLowerCase().indexOf(code) >= 0
        || c.EName?.toLowerCase().indexOf(code) >= 0);
    } else {
      // 院內代碼符合的顯示在前方 並排序
      var matched = dx.filter(c => c.Code?.toLowerCase().startsWith(code))
        .sort((a, b) => Compare(a.Code.toLowerCase(), b.Code.toLowerCase()));
      // 緊接著ICD10符合的項目 並排序
      matched = [...matched, ...dx.filter(c => !matched.some(dx => dx.Code == c.Code) // 排除掉已經符合的項目
        && c.ApplyCode?.toLowerCase().startsWith(code))
        .sort((a, b) => Compare(a.ApplyCode.toLowerCase(), b.ApplyCode.toLowerCase()))]
      // 緊接著ICD9符合的項目 並排序
      matched = [...matched, ...dx.filter(c => !matched.some(dx => dx.Code == c.Code) // 排除掉已經符合的項目
        && c.ICD9?.toLowerCase().startsWith(code))
        .sort((a, b) => Compare(a.ICD9.toLowerCase(), b.ICD9.toLowerCase()))]
      // 緊接著名稱符合的項目 並排序
      matched = [...matched, ...dx.filter(c => !matched.some(dx => dx.Code == c.Code) // 排除掉已經符合的項目
        && (c.Short?.toLowerCase().startsWith(code)
          || c.ShortNo?.toLowerCase().indexOf(code) >= 0
          || c.CName?.toLowerCase().indexOf(code) >= 0
          || c.EName?.toLowerCase().indexOf(code) >= 0))
        .sort((a, b) => Compare(a.CName?.toLowerCase().indexOf(code), b.CName?.toLowerCase().indexOf(code)
          || Compare(a.Code?.toLowerCase(), b.Code?.toLowerCase())))]
      //
      // var nameMatch = dx.filter(c => !matched.some(dx => dx.Code == c.Code) && (
      //   c.Short?.toLowerCase().startsWith(code)
      //   || c.CName?.toLowerCase().indexOf(code) >= 0
      //   || c.EName?.toLowerCase().indexOf(code) >= 0))
      //   .sort((a, b) => Compare(a.CName?.toLowerCase().indexOf(code), b.CName?.toLowerCase().indexOf(code)
      //     || Compare(a.Code?.toLowerCase(), b.Code?.toLowerCase())));
      // return codeMatch.concat(nameMatch);
      return matched
    }
  }

  /** 取全部院內診斷(GetAllDxOption 單一份，每筆已依起迄日期套對應版本 ICD9)，
   *  依看診日(currentHist.Register.RegDate)過濾起迄日期、剔除當下未生效/已失效的診斷，
   *  再依輸入字元篩選；供看診畫面選字/配盤/反查使用 */
  async getDiagListByEndDate(code: string, sortByMatch: boolean = false): Promise<DxOpt[]> {
    var dx = await this.clinicData.GetAllDxOption();
    // 依看診日期(RegDate)過濾起迄日期，剔除當下未生效/已失效的診斷
    var regDate = this.currentHist?.Register?.RegDate;
    if (regDate) {
      var reg = DateHelper.createDate(regDate);
      dx = dx.filter(c =>
        (c.StartDate == null || reg >= DateHelper.createDate(c.StartDate)) &&
        (c.EndDate == null || reg <= DateHelper.createDate(c.EndDate)));
    }
    var emptyCode = NullOrEmpty(code);
    if (emptyCode) {
      return dx;
    }
    code = code.toLowerCase();
    // 不排序(按照server端下來的Code順序)
    if (sortByMatch == false) {
      return dx.filter(c => emptyCode ? true
        : c.Code?.toLowerCase().startsWith(code)
        || c.ICD9?.toLowerCase().startsWith(code)
        || c.ApplyCode?.toLowerCase().startsWith(code)
        || c.Short?.toLowerCase().startsWith(code)
        || c.ShortNo?.toLowerCase().indexOf(code) >= 0
        || c.CName?.toLowerCase().indexOf(code) >= 0
        || c.EName?.toLowerCase().indexOf(code) >= 0);
    } else {
      // 院內代碼符合的顯示在前方 並排序
      var matched = dx.filter(c => c.Code?.toLowerCase().startsWith(code))
        .sort((a, b) => Compare(a.Code.toLowerCase(), b.Code.toLowerCase()));
      // 緊接著ICD10符合的項目 並排序
      matched = [...matched, ...dx.filter(c => !matched.some(dx => dx.Code == c.Code)
        && c.ApplyCode?.toLowerCase().startsWith(code))
        .sort((a, b) => Compare(a.ApplyCode.toLowerCase(), b.ApplyCode.toLowerCase()))]
      // 緊接著ICD9符合的項目 並排序
      matched = [...matched, ...dx.filter(c => !matched.some(dx => dx.Code == c.Code)
        && c.ICD9?.toLowerCase().startsWith(code))
        .sort((a, b) => Compare(a.ICD9.toLowerCase(), b.ICD9.toLowerCase()))]
      // 緊接著名稱符合的項目 並排序
      matched = [...matched, ...dx.filter(c => !matched.some(dx => dx.Code == c.Code)
        && (c.Short?.toLowerCase().startsWith(code)
          || c.ShortNo?.toLowerCase().indexOf(code) >= 0
          || c.CName?.toLowerCase().indexOf(code) >= 0
          || c.EName?.toLowerCase().indexOf(code) >= 0))
        .sort((a, b) => Compare(a.CName?.toLowerCase().indexOf(code), b.CName?.toLowerCase().indexOf(code)
          || Compare(a.Code?.toLowerCase(), b.Code?.toLowerCase())))]
      return matched
    }
  }

  async checkAlternative(rxId: number) {
    var data = await this.rxApi.GetRxById(rxId);
    if (data) {
      return data.AlternativeRxId;
    } else {
      return null;
    }
  }

  async getDentalICD10CM() {
    if (!this.ICD10CMs) {
      this.ICD10CMs = await this.opdApi.GetDentalICD10CMs();
    }
  }

  async getDentalICD10PCS() {
    if (!this.ICD10PCSs) {
      this.ICD10PCSs = await this.opdApi.GetDentalICD10PCs();
    }
  }

  async getOrderList(code: string, typeArray: number[], sortByMatch: boolean = false): Promise<RxOpt[]> {
    //var editopt = await this.histApi.getEditOptions();
    //console.log(editopt);
    var rx = await this.clinicData.GetRxOption();
    var rsInData = await this.clinicData.GetRsOption();
    rsInData = rsInData.sort((a, b) => a.MainSetId - b.MainSetId); // 因為網路傳輸導致資料未按MainSetId排序，所以要先排序一下
    var needRxSet = typeArray.includes(0);

    if (this.IsChineseMode) {
      needRxSet = typeArray.includes(0) || typeArray.length === 0;
    }
    //var rsInData = editopt.rs.sort((a, b) => a.MainSetId - b.MainSetId);  // 因為網路傳輸導致資料未按MainSetId排序，所以要先排序一下
    var rxInType: RxOpt[] = [];
    if (rsInData.length > 0 && needRxSet) {
      var oId = 0;
      var nId = 0;
      for (let index = 0; index < rsInData.length; index++) {
        const item = rsInData[index];
        nId = item.MainSetId;
        if (nId != oId) {
          var d: RxOpt = new RxOpt();
          d.Id = item.RxId;
          d.IsByOral = false;
          d.RxCode = item.RsCode; //item.RxCode;
          d.ProdName = item.ProdName;
          d.Type = 0;
          d.StdCode = item.StdCode;
          d.MainSetId = item.MainSetId;
          d.RsCode = item.RsCode;
          d.IsDrugStatus = false;
          d.AlternativeRxId = item.AlternativeRxId;
          d.FlagDescription = 'MAINSET;';
          d.Surs = item.Surs;
          d.SPTXs = item.SPTXs;
          rxInType.push(d);
        }
        oId = nId;
      }
    }

    // var rxInType = editopt.rx;
    //editopt.rx.forEach(x => {
    rx.forEach(x => {
      rxInType.push(x);
    });

    if (typeArray.length > 0) {
      // rxInType = editopt.rx.filter(c => typeArray.includes(c.Type) || c.Type == 0);
      // #17710: X5188 盤選->組套 無法移動盤選的內容
      // 濾掉rx.Type 為0的資料，避免混到套餐
      rxInType = rxInType.filter(c =>
        typeArray.includes(c.Type) && (c.Type !== 0 || (c.MainSetId != null && c.MainSetId !== 0))
      );

    }

    // 顯示通用名模式(1)：無通用名的醫令整筆剔除(套餐保留)
    const primaryName = this.editOption?.histParams?.DisplayRxName || '0';
    if (primaryName === '1') {
      rxInType = rxInType.filter(c => c.FlagDescription?.includes('MAINSET;') || !!c.GXName);
    }

    var emptyCode = NullOrEmpty(code);
    if (emptyCode) {
      return rxInType;
    }

    code = code.toLowerCase()
    if (sortByMatch) {
      var codeMatch = rxInType.filter(c => c.RxCode?.toLowerCase().startsWith(code))
        .sort((a, b) => Compare(a.RxCode.toLowerCase(), b.RxCode.toLowerCase()));
      if (this.IsPharmacyMode) {
        //藥局才比對StdCode
        var stdCodeMatch = rxInType.filter(c => !codeMatch.some(rx => rx.RxCode == c.RxCode) && c.StdCode?.toLowerCase().indexOf(code) >= 0)
          .sort((a, b) => Compare(a.StdCode?.toLowerCase().indexOf(code), b.StdCode?.toLowerCase().indexOf(code)));
        codeMatch = codeMatch.concat(stdCodeMatch)
      }
      if (this.IsChineseMode) {
        // 中醫才比對拼音碼
        var shortNoMatch = rxInType.filter(c => !codeMatch.some(rx => rx.RxCode == c.RxCode) && c.ShortNo?.toLowerCase().startsWith(code))
          .sort((a, b) => Compare(a.ShortNo?.toLowerCase(), b.ShortNo?.toLowerCase()));
        codeMatch = codeMatch.concat(shortNoMatch);
      }
      // 依參數決定 商品名(ProdName)/通用名(GXName) 的清單先後，build 一段 concat 一段以正確去重
      const buildProdMatch = () => rxInType.filter(c => !codeMatch.some(rx => rx.RxCode == c.RxCode) && c.ProdName?.toLowerCase().indexOf(code) >= 0)
        .sort((a, b) => Compare(a.ProdName?.toLowerCase().indexOf(code), b.ProdName?.toLowerCase().indexOf(code)));
      const buildGxMatch = () => rxInType.filter(c => !codeMatch.some(rx => rx.RxCode == c.RxCode) && c.GXName?.toLowerCase().indexOf(code) >= 0)
        .sort((a, b) => Compare(a.GXName?.toLowerCase().indexOf(code), b.GXName?.toLowerCase().indexOf(code)));
      if (primaryName === '1') {
        codeMatch = codeMatch.concat(buildGxMatch());
        codeMatch = codeMatch.concat(buildProdMatch());
      } else {
        codeMatch = codeMatch.concat(buildProdMatch());
        codeMatch = codeMatch.concat(buildGxMatch());
      }
      // 成分名(永遠最後)
      var iiNameMatch = rxInType.filter(c => !codeMatch.some(rx => rx.RxCode == c.RxCode) && c.IIName?.toLowerCase().indexOf(code) >= 0)
        .sort((a, b) => Compare(a.IIName?.toLowerCase().indexOf(code), b.IIName?.toLowerCase().indexOf(code)));
      codeMatch = codeMatch.concat(iiNameMatch);

      if (this.IsPharmacyMode) {
        // 因為藥局有標準藥 所以先只顯示前300筆吻合的
        codeMatch = codeMatch.filter((x, i) => i < 300);
      }

      return codeMatch;
    } else {
      var data = rxInType.filter(c => (c.RxCode?.toLowerCase().startsWith(code)
        || c.RsCode?.toLowerCase().startsWith(code)
        || c.ProdName?.toLowerCase().indexOf(code) >= 0
        || c.GXName?.toLowerCase().indexOf(code) >= 0
        || c.IIName?.toLowerCase().indexOf(code) >= 0));
      return data;
    }
    // const types = this.convertToString(typeArray);
    // let query = 'GetOrderList?code=' + code + '&types=' + types;
    // query = this.queryAddCount(query, count);
    // return this.api.get(query);
  }

  async getChiOrderList(code: string, orderClass: string, sortByMatch: boolean): Promise<RxOpt[]> {

    return await this.getOrderList(code, orderClass == '001' ? [2] :
      orderClass == '002' ? [202] :
        orderClass == '003' ? [102, 203] : [], sortByMatch)
    var rx = await this.clinicData.GetRxOption();
    return rx;

    // if(orderClass){
    //   return data.filter(x=>x.SearchCode1==orderClass) as any;
    // }else{
    //   return data as any;
    // }

  }
  async getOrderListByIds(ids: number[]): Promise<RxOpt[]> {
    //var editopt = await this.histApi.getEditOptions();
    //console.log(editopt);
    var rx = await this.clinicData.GetRxOption();
    return rx.filter(x => ids.includes(x.Id));

  }
  async getRxByOrderList(stdCode: string): Promise<Rx> {

    var rxOpts = await this.clinicData.GetRxOption();
    var rx = rxOpts.find(x => x.StdCode == stdCode);
    if (rx) return; // 有加醫令就不處理
    var rxNew = this.histApi.GetOrderByStdCodeAsync(stdCode);
    return rxNew;
  }
  //#endregion


  // #region route service --------------------
  routeToOpdList() {
    this.clearRestore(this.currentHist?.Register?.Id);
    const url = this.routeInfo.makeFullUrl('/registers/opd-list');
    this.router.navigate([url]);
    this.surClear();
    this.sptxClear();
  }

  routeToHistList() {
    this.clearRestore(this.currentHist?.Register?.Id);
    const url = this.routeInfo.makeFullUrl('/patients/patient-hist');
    this.router.navigate([url]);
    this.surClear();
    this.sptxClear();
  }

  routeToPharmacyList() {
    this.clearRestore(this.currentHist?.Register?.Id);
    const url = this.routeInfo.makeFullUrl('/pharmacy/phar-list');
    this.router.navigate([url]);
    this.surClear();
    this.sptxClear();
  }

  async changePatientHist(rId: number) {
    this.clearRestore(this.currentHist?.Register?.Id);
    var url = this.routeInfo.makeFullUrl('/hist');
    this.router.navigateByUrl(url, { skipLocationChange: true }).then(() => {
      if (UserCache.getLoginUser().Clinic.Type == ClinicTypeEnum.DentistClinic) {
        url = this.routeInfo.makeFullUrl('/hist/record-dental');
      } else {
        url = this.routeInfo.makeFullUrl('/hist/record');
      }
      this.router.navigate([url, { regId: rId }])
    });
  }
  async getRahbitUser(date: Date) {
    var hst001 = await this.clinicData.getParam("SCH001");
    var timeSec = hst001?.CanScheduledTherapistMonth ? this.currentHist?.Register.TimeSec ?? 0 : 0;

    if (this.rahbitUserDate) {
      if (this.rahbitUserDate.getFullYear() == date.getFullYear() &&
        this.rahbitUserDate.getMonth() == date.getMonth() && this.rahbitUserDate.getDate() == date.getDate()) return this.rahbitUser;
    }
    if (FunctionEnable.EnableClientAdvCache) {
      this.rahbitUser = await this.clinicData.GetRehabitMedUesr(date);
    } else {
      this.rahbitUser = await this.regApi.GetRehabitMedUesrs(date);
    }
    this.tempTherapist =  new TherapistLastRecordDto();
    this.isUsingPT = false;
    this.isUsingOT = false;
    this.isUsingST = false;
    this.isUsingPRT = false;

    if (timeSec > 0) {
      this.rahbitUser = this.rahbitUser.filter(x => Number(x.TimeSec) == timeSec);

    }
    if (this.rahbitUser?.length > 0 && DateHelper.compareToday(date)) {
      await this.get復健當日最後復健師();
    }
    this.isallowSaving = false;
    return this.rahbitUser;
  }
  getRahbitUserByPG(positionNum: number): ValueTextPair[] {
    if (!this.rahbitUser?.length) return [];

    const config = PG_MAP[positionNum];
    if (!config) return [];

    const { key, code } = config;

    const valuetext = this.rahbitUser
      .filter(x => x.PositionCode === code)
      .map(u => ({
        text: `${u.Account}.${u.Name}`,
        value: u.CId
      }));
    console.log('getRahbitUserByPGisallowSaving', this.isallowSaving, this.chosenTherapist);
    var oldMedId = this.tempTherapist[key] ?? '';
    if (!NullOrEmptyTrim(oldMedId)){
       this.isallowSaving = false;

    }
    else if (!this.isallowSaving && this.chosenTherapist) {
      var medId = this.chosenTherapist[key] ?? '';
      var newDto = this.getUserFromType(medId, valuetext);
      this.chosenTherapist[key] = newDto;
      this.isallowSaving = true;
    }

    return valuetext;
  }
  public async get復健當日最後復健師() {
    var sch001 = await this.clinicData.getParam("SCH001");
    if (sch001?.TherapistScheduledRunning != 2) return this.chosenTherapist = TherapistLastRecordDto.fromString();
    this.chosenTherapist = TherapistLastRecordDto.fromString(sch001.TherapistLastRecord);
  }
  public get復健代入復健師(positionNum: number) {
    const config = PG_MAP[positionNum];
    var medId = '';
    if (!config) return medId;

    const { key, code, flag } = config;
    if (!NullOrEmptyTrim(this.tempTherapist?.RegDate) && !NullOrEmptyTrim(this.tempTherapist[key])) {
      medId = this.tempTherapist[key];

    }
    else if (this.chosenTherapist && !NullOrEmptyTrim(this.chosenTherapist[key])) {
      medId = this.chosenTherapist[key];

    }
    return medId;
  }
  public async set得到的復健師(ther: ValueTextPair) {
    var sch001 = await this.clinicData.getParam("SCH001");
    if (sch001?.TherapistScheduledRunning != 2) return;

  }
  public async update復健當日最後復健師(): Promise<TherapistLastRecordDto> {
    var sch001 = await this.clinicData.getParam("SCH001");
    var str = this.chosenTherapist.toString();
    if (sch001?.TherapistScheduledRunning != 2 && this.isallowSaving && !NullOrEmptyTrim(this.tempTherapist?.RegDate)) return;
    try {
      await this.paramApi.UpdateParamGroup(ParamGroupEnum.SCH001, { 'TherapistLastRecord': str } as any);
      this.notification.showSuccess('更新成功');
      return this.chosenTherapist;
    } catch (e) {
      this.notification.showError(e);
    }
  }

  getUserFromType(
    medId: string,
    dropData: ValueTextPair[]
  ): string {

    if (!dropData || dropData.length === 0) {
      return '';
    }

    const index = dropData.findIndex(x => x.value === medId);

    // 找不到 或 已是最後一筆 → 用第一筆
    if (index === -1 || index === dropData.length - 1) {
      return dropData[0].value;
    }

    // 找到 → 回傳下一筆的 value
    return dropData[index + 1].value;
  }
  handleUser(dto: TherapistLastRecordDto, type: string) {
    var positionCode = '';
    var medId = '';
    switch (type) {
      case 'PT':
        positionCode = '20';
        medId = dto.PT;
        break;
      case 'OT':
        positionCode = '23';
        medId = dto.OT;
        break;
      case 'ST':
        positionCode = '24';
        medId = dto.ST;
        break;
      case 'PRT':
        positionCode = '22';
        medId = dto.PRT;

        break;
      default:
        break;
    }
    var valuetext = this.rahbitUser.filter(x => x.PositionCode == positionCode).map(user => { return { text: user.Account + '.' + user.Name, value: user.CId } });
    return this.getUserFromType(medId, valuetext);

  }
    setTempRahbitUserByPG(positionNum: number,medId: string){
    if (!this.rahbitUser?.length) return '';

    const config = PG_MAP[positionNum];
    if (!config) return '';

    const { key, code } = config;
    if (!NullOrEmptyTrim(this.tempTherapist[key]))return;
    this.tempTherapist[key]=medId;

  }
  // #endregion route service
  updateDrugByClinicDefault(drug: Rx): Rx {
    // console.log('updateDrugByClinicDefault >>>>>', drug);
    var clinicDefault = this.EditOptions.histParams
    drug = Rx.fromData(drug);
    // ------------------------------------------------------
    if (Rx.isCommonDrug(drug)) {
      if (!drug.DefaultDose) {
        drug.DefaultDose = clinicDefault.DefaultDose;
      }
      if (!drug.DefaultFrequency) {
        drug.DefaultFrequency = clinicDefault.DefaultFrequency;
      }
      if (!drug.DefaultDays) {
        drug.DefaultDays = clinicDefault.DefaultDays;
      }
      if (!drug.DefaultWay) {
        drug.DefaultWay = clinicDefault.DefaultWay;
      }
    } else {
      drug.DefaultDose = drug.DefaultDose ?? 1;
      drug.DefaultFrequency = drug.DefaultFrequency ?? '1';
      drug.DefaultDays = drug.DefaultDays ?? 1;
      drug.DefaultWay = drug.DefaultWay ?? '';
    }

    return drug;
  }
  //#region 病歷編輯暫存
  storeHistTimer: any;
  storeHistInterval = 5000;
  enableStoreHist() {
    return !UserCache.IsPharmacyMode() && !UserCache.IsChineseMode() && (BaseConfig.isDebug() || this.editOption.histParams.RestoreEditing)
  }
  /** 開始準備暫存 10秒 */
  public beginStoreHist(getHist: () => WholeHist) {
    if (!this.enableStoreHist()) {
      return;
    }
    // console.log('beginStoreHist');
    this.storeHistTimer = setTimeout(() => {
      var h = getHist();
      if (!h) {
        //取病歷方法為空則終止
        //this.clearRestore();
        return;
      }
      this.storeHist(h);
      this.beginStoreHist(getHist);
    }, this.storeHistInterval);
  }
  /** 暫存編輯中病歷 */
  storeHist(h: WholeHist) {
    if (!this.enableStoreHist()) {
      return;
    }
    // 前次儲存的
    var h2: WholeHist = this.localStorage.getItem('HistRcd_' + h.Register.Id);
    // 當前編輯中的

    // 有差異才更新進LocalStorage
    if (!this.checkNeedStore(h, h2)) {
      // console.log('Data No need store');
      return;
    } else {
      this.localStorage.setItem('HistRcd_' + h.Register.Id, h);
      console.log('Data stored');
    }

  }
  // 比對有無差異
  checkNeedStore(d1: WholeHist, d2: WholeHist) {
    if (!d2) {
      return true;
    }
    Or
    if (!StringEqual(d1.Hist.CC, d2.Hist.CC)
      || !StringEqual(d1.Hist.PE, d2.Hist.PE)
      || !StringEqual(d1.Hist.Dx1, d2.Hist.Dx1)
      || !StringEqual(d1.Hist.Dx2, d2.Hist.Dx2)
      || !StringEqual(d1.Hist.Dx3, d2.Hist.Dx3)
      || !StringEqual(d1.Hist.Dx4, d2.Hist.Dx4)
      || !StringEqual(d1.Hist.Dx5, d2.Hist.Dx5)
      || !StringEqual(d1.Hist.Dx6, d2.Hist.Dx6)) {
      return true;
    }
    for (let i = 0; i < d1.Hist.HRxs.length; i++) {
      let hrx = d1.Hist.HRxs[i]
      var x = d2.Hist.HRxs[i];
      // 其中一邊有值 且非完全相等
      if ((x.RxCode || hrx.RxCode) && !(StringEqual(x.RxCode, hrx.RxCode) && x.SPRule == hrx.SPRule
        && x.QTY == hrx.QTY && StringEqual(x.Freq, hrx.Freq) && x.Days == hrx.Days
        && x.DailyDose == hrx.DailyDose && x.TotalDose == hrx.TotalDose
        && StringEqual(x.Way, hrx.Way) && x.DispTP == hrx.DispTP && StringEqual(x.Remark, hrx.Remark)
        && x.BeginDate == hrx.BeginDate && x.EndDate == hrx.EndDate && x.MedID == hrx.MedID)
      ) {
        return true
      }
    }
    if (d1.VitalSign.BT != d1.VitalSign.BT ||
      d1.VitalSign.DBP != d1.VitalSign.DBP ||
      d1.VitalSign.SBP != d1.VitalSign.SBP ||
      d1.VitalSign.DueDate != d1.VitalSign.DueDate ||
      d1.VitalSign.Head != d1.VitalSign.Head ||
      d1.VitalSign.Height != d1.VitalSign.Height ||
      d1.VitalSign.IsPregnant != d1.VitalSign.IsPregnant ||
      d1.VitalSign.LMPDate != d1.VitalSign.LMPDate ||
      d1.VitalSign.Pulse != d1.VitalSign.Pulse ||
      d1.VitalSign.SpO2 != d2.VitalSign.SpO2 ||
      d1.VitalSign.VSDateTime != d1.VitalSign.VSDateTime ||
      d1.VitalSign.Weight != d1.VitalSign.Weight) {
      return true;
    }

    return false;
  }
  getDisplayIsqnoValue(value: string, data: any): string {
    const { IType, SameTreat, ReCardDate, Icno, INote, Isqno } = data;

    // 1. 處理 IC06 的情況：如果有 INote 則優先顯示
    if (value === 'IC06' && INote) {
      return INote;
    }

    // 2. 處理特定身分轉為 IC09
    if (value === 'B9' || value === 'B1') {
      return 'IC09';
    }
    if (value === '10') {
      return 'IC10';
    }
    // 3. 處理「欠卡/還卡」特殊邏輯 (IType 為 '3' 且 SameTreat 不是 '2')
    if (IType === '3' && SameTreat !== '2') {
      const specialIcnos = ['C4', 'MT', 'MSPT'];
      // 如果不是特殊的 Icno，則轉換為 欠/還卡
      if (!specialIcnos.includes(Icno)) {
        return ReCardDate != null ? '還卡' : '欠卡';
      }
    }

    // 4. 預設回傳原始值
    return value;
  }
  /** 暫存病歷還原 */
  public async restore(d: WholeHist): Promise<WholeHist> {
    if (!this.enableStoreHist()) {
      return;
    }
    var h: WholeHist = this.localStorage.getItem('HistRcd_' + d.Register.Id);

    if (h && this.checkNeedStore(d, h)) {
      var res = await this.userConfirmService.showConfirm({
        msg: '此病歷有編輯中的版本，是否要還原？',
        title: '發現未儲存的內容',
      })
      if (res) {
        var col: (keyof Hist)[] = ['CC', 'PE',
          'Dx1', 'Dx2', 'Dx3', 'Dx4', 'Dx5', 'Dx6',
          'Dx1Name', 'Dx2Name', 'Dx3Name', 'Dx4Name', 'Dx5Name', 'Dx6Name'];
        col.forEach((x: string) => d.Hist[x] = h.Hist[x]);

        d.Hist.HRxs = h.Hist.HRxs;
        d.VitalSign = h.VitalSign;
      } else {
        this.clearRestore(d.Register.Id);
        return null;
      }
    }
    this.clearRestore(d.Register.Id);
    return d
  }
  public clearRestore(id: number) {
    if (!this.enableStoreHist()) {
      return;
    }
    this.localStorage.removeItem('HistRcd_' + id);
    clearTimeout(this.storeHistTimer);
  }

  /** 取得最新的暫存HistRcd */
  public getHistRcd(d: WholeHist): WholeHist | null {
    const id = d?.Register?.Id;
    if (!id) return null;

    const raw = this.localStorage.getItem('HistRcd_' + id);
    if (!raw) return null;

    let h: WholeHist;
    try {
      h = typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch {
      return null;
    }
    if (!h?.Hist || !h?.VitalSign) return null;
    d.Hist ??= {} as any;
    d.VitalSign ??= {} as any;
    d.Hist.HRxs = h.Hist.HRxs;
    d.VitalSign = h.VitalSign;

    return d;
  }

  // 比對Rx, Dx有無差異
  RxDxChanged(d1: WholeHist, d2: WholeHist) {
    // if (!d2) {
    //   return true;
    // }
    // Or
    // if (!StringEqual(TrimEnd(d1.Hist.Dx1, ' '), TrimEnd(d2.Hist.Dx1, ' '))
    //   || !StringEqual(TrimEnd(d1.Hist.Dx2, ' '), TrimEnd(d2.Hist.Dx2, ' '))
    //   || !StringEqual(TrimEnd(d1.Hist.Dx3, ' '), TrimEnd(d2.Hist.Dx3, ' '))
    //   || !StringEqual(TrimEnd(d1.Hist.Dx4, ' '), TrimEnd(d2.Hist.Dx4, ' '))
    //   || !StringEqual(TrimEnd(d1.Hist.Dx5, ' '), TrimEnd(d2.Hist.Dx5, ' '))
    //   || !StringEqual(TrimEnd(d1.Hist.Dx6, ' '), TrimEnd(d2.Hist.Dx6, ' '))) {
    //   // console.log('different dx');
    //   return true;
    // }
    if (this.DxChanged(d1, d2)) {
      return true;
    }
    if (this.RxChanged(d1, d2)) {
      return true;
    }
    // console.log('All same');
    return false;
  }
  RxChanged(d1: WholeHist, d2: WholeHist) {
    var ubound = d1?.Hist?.HRxs.length;
    if (d2.Hist.HRxs.length > d1?.Hist?.HRxs.length) ubound = d2.Hist.HRxs.length;
    for (let i = 0; i < ubound; i++) {
      let hrx = d1?.Hist?.HRxs[i];
      var x = d2.Hist.HRxs[i];
      if (hrx && x) {
        // 兩邊都有值 且非完全相等
        var BeginDate1 = new Date(hrx.BeginDate);
        var BeginDate2 = new Date(x.BeginDate);
        var EndDate1 = new Date(hrx.EndDate);
        var EndDate2 = new Date(x.EndDate);
        if (!(StringEqual(TrimEnd(x.RxCode ?? '', ' '), TrimEnd(hrx.RxCode ?? '', ' ')) || x.SPRule != hrx.SPRule
          || x.QTY != hrx.QTY && StringEqual(x.Freq ?? '', hrx.Freq ?? '') || x.Days != hrx.Days
          || x.DailyDose != hrx.DailyDose || x.TotalDose != hrx.TotalDose
          || !StringEqual(x.Way ?? '', hrx.Way ?? '') || x.DispTP != hrx.DispTP && !StringEqual(x.Remark ?? '', hrx.Remark ?? '')
          && BeginDate1 != BeginDate2 && EndDate1 != EndDate2 && x.MedID != hrx.MedID)) {
          console.log('different Rx 1');
          return true;
        }
      } else if (!(!hrx && !x)) { // 其中一邊有值
        // console.log('different Rx 2');
        return true;
      }
    }
    // console.log('All same');
    return false;
  }
RxSelfChanged(d1: WholeHist, d2: WholeHist) {
  console.log('RxSelfChanged');

  // 1. 安全地取得過濾後的處方陣列，避免 undefined 崩潰
  const isSelfPay = d2?.Register?.ICode === RegisterConst.ICode_000_SelfPay;
  
  const d1hrxs = (isSelfPay ? d1?.Hist?.HRxs : d1?.Hist?.HRxs?.filter(x => x.SPRule == 2)) ?? [];
  const d2hrxs = (isSelfPay ? d2?.Hist?.HRxs : d2?.Hist?.HRxs?.filter(x => x.SPRule == 2)) ?? [];

  // 2. 如果數量不一致，代表處方一定有變更
  if (d1hrxs.length !== d2hrxs.length) {
    console.log('different Rx: Count mismatch');
    return true;
  }

  // 3. 逐筆比對欄位 (假設順序固定，若順序不固定需先根據 MedID 排序)
  for (let i = 0; i < d1hrxs.length; i++) {
    const hrx = d1hrxs[i];
    const x = d2hrxs[i];

    // 將複雜的欄位比對拆解，只要有任何一個「不相等」，就代表有變更
    const isChanged = 
      !StringEqual(TrimEnd(x.RxCode ?? '', ' '), TrimEnd(hrx.RxCode ?? '', ' ')) ||
      x.SPRule !== hrx.SPRule ||
      x.QTY !== hrx.QTY ||
      !StringEqual(x.Freq ?? '', hrx.Freq ?? '') ||
      x.Days !== hrx.Days ||
      x.DailyDose !== hrx.DailyDose ||
      x.TotalDose !== hrx.TotalDose ||
      !StringEqual(x.Way ?? '', hrx.Way ?? '') ||
      x.DispTP !== hrx.DispTP ||
      x.MedID !== hrx.MedID 

    if (isChanged) {
      console.log(`different Rx at index ${i}`);
      return true;
    }
  }

  return false;
}
  DxChanged(d1: WholeHist, d2: WholeHist) {
    if (!StringEqual(TrimEnd(d1?.Hist?.Dx1, ' '), TrimEnd(d2.Hist.Dx1, ' '))
      || !StringEqual(TrimEnd(d1?.Hist?.Dx2, ' '), TrimEnd(d2.Hist.Dx2, ' '))
      || !StringEqual(TrimEnd(d1?.Hist?.Dx3, ' '), TrimEnd(d2.Hist.Dx3, ' '))
      || !StringEqual(TrimEnd(d1?.Hist?.Dx4, ' '), TrimEnd(d2.Hist.Dx4, ' '))
      || !StringEqual(TrimEnd(d1?.Hist?.Dx5, ' '), TrimEnd(d2.Hist.Dx5, ' '))
      || !StringEqual(TrimEnd(d1?.Hist?.Dx6, ' '), TrimEnd(d2.Hist.Dx6, ' '))) {
      return true;
    }
    return false;
  }
  //#endregion
  surClear() {
    console.log('📝 [病歷服務] surClear 被呼叫：清空 currentHistSurs 與 delCodes');
    this.currentHistSurs = [];
    this.delCodes = [];
  }
  sptxClear() {
    this.currentHistSPTXs = [];
    this.delSPTXCodes = [];
  }
  mainSetClear() {
    this.MainSetCode = '';
    this.MainSetName = '';
  }
  surDelOneRow(val: string) {
    if (val) {
      var includes = this.currentHistSurs.find(x => x.Code == val);
      if (includes) {
        this.currentHistSurs = this.currentHistSurs.filter(x => x.Code != includes.Code);
        this.delCodes.push(includes);
      }
    }
  }
  sptxDelOneRow(val: string) {
    if (val) {
      var includes = this.currentHistSPTXs.find(x => x.Code == val);
      if (includes) {
        this.currentHistSPTXs = this.currentHistSPTXs.filter(x => x.Code != includes.Code);
        this.delSPTXCodes.push(includes);
      }
    }
  }
  /**簡易的過濾 */
  get復健DisableClick(input: HistOrder): boolean {
    if (!input) return false;
    var stdCode = input.StdCode;
    if (stdCode == '42016C' || stdCode == '44010C ') return true;
    const match = stdCode.match(/^430(\d{2})C$/);
    if (!match) return false;
    const number = parseInt(match[1], 10);
    const excluded = [27, 28, 29];
    if (number >= 10 && number <= 38 && !excluded.includes(number)) return true;
    return false;
  }
  setSur(key: string, input: string[], isRs = false) {
    var typesur = new RxCodeSurs();
    if (!key && input.length < 1) return;
    var includes = this.currentHistSurs.find(x => x.Code == key && x.IsRs == isRs)
    if (includes) {
      includes.Surs = input;
      console.log('📝 [病歷服務] setSur - 更新現有 Surs', { key: key, input: input, isRs: isRs });
    }
    else {
      typesur.Code = key;
      typesur.IsRs = isRs;
      typesur.Surs = input;
      this.currentHistSurs.push(typesur);
      console.log('📝 [病歷服務] setSur - 新增 Surs', { key: key, input: input, isRs: isRs });
    }
    // var currentSuR =this.currentHistSurs?.length > 0 ? this.currentHistSurs?.split(',').concat(['', '', '']):['', '', ''];
    // var combineSur = [...currentSuR,...input];
    // Distinct(combineSur);
    // this.currentHistSurs = combineSur.join(',');
  }
  setSPTX(key: string, input: string[], isRs = false) {
    var typesptx = new RxCodeSPTXs();
    if (!key && input.length < 1) return;
    var includes = this.currentHistSPTXs.find(x => x.Code == key && x.IsRs == isRs)
    if (includes) {
      includes.SPTXs = input;
    }
    else {
      typesptx.Code = key;
      typesptx.IsRs = isRs;
      typesptx.SPTXs = input;
      this.currentHistSPTXs.push(typesptx);
    }
  }
  getVitalSignEditValue() {
    var vt = null;
    this.onGetVT.emit((a) => {
      vt = a;
    });
    return vt;
  }
  public getPharMedFeeCount(pharID: number) {
    var pharMed = '';
    if (this.currentEnterRoom?.allPhar) {
      var dto = this.currentEnterRoom?.allPhar;
      const count = dto.PharIDCount[pharID] || 0;  // 11
      if (pharID == 0) return pharMed;
      else if (count > dto.Ovr_dsc) {
        var two = count - dto.Ovr_dsc;
        pharMed = ` 第一段：${dto.Ovr_dsc}/${dto.Ovr_dsc} 第二段：${two}/${dto.Ovr_xxx}`;
      }
      else {
        pharMed = ` 第一段：${count}/${dto.Ovr_dsc}`;
      }
    }
    return pharMed;
  }
  CopyFomHistView() {
    this.onCopyFomView.emit();
  }
  async SendJson米菲爾(histData: WholeHist): Promise<VisionApiResult> {
    let paramHst001 = await this.clinicData.getParam("HST001");
    if (!(paramHst001 && paramHst001.WFRPACSDIR)) {
      return;
    }

    var orders: HistOrder[] = [];
    orders = histData.Hist.HRxs.filter(x => x.RxType == 7 || x.RxType == 6);
    // console.log('odData >>>>', orders);
    var odCode = '';
    if (orders.length > 0) {
      orders.forEach(odr => {
        odCode = odCode + odr.StdCode + ',';
        // console.log('odCode >>>>', odCode);
      });
    }

    let clinic = UserCache.getLoginUser().Clinic;
    var reg = histData.Register;
    var pat = histData.Patient;
    var obj = {
      pid: pat.PatientNo,
      name: pat.CName,
      sex: pat.Sex == 0 ? 'F' : 'M',
      // 西元年
      stdate: DateHelper.getFormatedDateString(reg.RegDate, false, '', false),// DateHelper.formatROCDate(reg.RegDate),
      stime: DateHelper.getTimeString(reg.RegDate),
      no: clinic?.NHICode,
      nc: this.generateM56(reg.Nhictp, reg.SameTreat, clinic.Type, clinic.NHIType),
      //民國年
      dd: DateHelper.formatROCDate(new Date()),
      cc: reg.Nhictp,
      cs: reg.Icno,
      cm: "1",
      id: pat.CId,
      //民國年
      bd: DateHelper.formatROCDate(pat.Birthday),
      od: odCode,
      ri: reg.DoctorCId,
      rn: reg.DoctorName,
    }

    var fileName = `${DateHelper.formatROCDate(new Date(), false, true)}-${pat.PatientNo}`;

    var folderName = paramHst001.WFRPACSDIR;
    var jsonFileName = `${folderName}\\${fileName}.json`;
    //去除屬性名稱的雙引號JSON
    var js = this.toObjectLiteralString(obj); //JSON.stringify(obj)
    var result = await this.hcrService.SaveTextAs(jsonFileName, js, false, 'big5');
    return result;
  }
  toObjectLiteralString(obj: any): string {
    var kv = Object.entries(obj)
      .map(([k, v]) => `${k}:"${v}"`)
      .join(',');
    return `{${kv}}`;
  }
  async OpenUrlFrom米菲爾(histData: WholeHist) {
    let paramHst001 = await this.clinicData.getParam("HST001");
    if (!(paramHst001 && paramHst001.WFRPACSIP)) {
      return;
    }
    // 1.SSHOW_DT("1000101","1","YMD")→"2011年01月01日"
    // &stdate=" + SSHOW_DT(CO05T.TDATE, "", "YMD")
    var reg = histData.Register;
    var pat = histData.Patient;
    var url = `http://${paramHst001.WFRPACSIP}/dicom/multimain?ucid=${reg.DoctorCId}&pid=${pat.PatientNo}&stdate=${DateHelper.getFullDateString(reg.RegDate)}&range=1y`
    window.open(url);


  }
  async queryPharERX(qrcodedata: string, data: any) {
    var sign = await this.GetPharSendSign();

    var obj = {
      "sHospId": data.hospid,
      "sClientRandom": sign?.random,
      "sSignature": sign?.signStr,
      "sSamId": data.samId,
      "sPatId": data.patientCId,
      "sTreatNum": data.ItreatnumOri,
      "sTreatD": data.OriDate,
      "sRecipeType": data.RecipeType,
      "sQRSignature": Array(400).fill('0').map(x => '0').join(''),
    }
    console.log('queryPharERX', JSON.stringify(obj), obj);
    var ret = await this.hcrService.SendFromUrl('https://medws.nhi.gov.tw/api/irie3100/QryRecipeTime',
      JSON.stringify(obj), 'application/json', '', {}
    )
    return ret;
  }
  async getPharERX(qrcodedata: string, data: any) {
    var sign = await this.GetPharSendSign();

    var obj = {
      "sHospId": data.hospid,
      "sClientRandom": sign?.random,
      "sSignature": sign?.signStr,
      "sSamId": data.samId,
      "sPatId": data.patientCId,
      "sTreatNum": data.ItreatnumOri,
      "sTreatD": data.OriDate,
      "sRecipeType": data.RecipeType,
      "sQRSignature": Array(400).fill('0').map(x => '0').join(''),
    }
    console.log('getPharERX', JSON.stringify(obj), obj);
    var ret = await this.hcrService.SendFromUrl('https://medws.nhi.gov.tw/api/irie3200/QryRecipeData',
      JSON.stringify(obj), 'application/json', '', {}
    )
    return ret;
  }
  async SearchKey(clinicCode: string, samId: string) {
    let signKey = '';
    let randomKey = '';
    var getKeyRandom = await this.hcrService.VisionApi.GetVPNGetRandomXAndSignX('3', '26');
    if (getKeyRandom?.Data) {
      signKey = getKeyRandom.Data.SignX
      randomKey = getKeyRandom.Data.RandomX;
    }
    if (!NullOrEmptyTrim(signKey) && !NullOrEmptyTrim(randomKey)) {
      var queryObj = {
        "sHospId": clinicCode,
        "sClientRandom": randomKey,
        "sSignature": signKey,
        "sSamId": samId,
      }
      console.log('SearchKey', JSON.stringify(queryObj), queryObj);
      var retQuery = await this.hcrService.SendFromUrl('https://medws.nhi.gov.tw/api/irie4000/QryFileKeyValue',
        JSON.stringify(queryObj), 'application/json', '', {}
      )
      console.log('retQuery:', retQuery);
      if (retQuery.Successed && retQuery.Returns) {
        var returnsObj = JSON.parse(retQuery.Returns);
        return returnsObj?.sKey ?? '';
      }
    }
    return '';
  }

  async GetPharSendSign() {
    let signStr = "2597D7E5CBEA5A92C5C35442FA89312131022746093A00A8ECC7FC1F5B42CB49DE8DEBD22840FC409A314FC33AD35BA0776A00D2C51F8DAE515D290F826F0533D2A721C335DBF3BEE318971A68A857ECFFE1BC816C56904826CFE6E80234C5AFD0E95B4064A976554466A738A2E6CF6D335600A48D89BA240F177DCD5E7D1A9655AF214A25A1A8B9715EAAF328E524BA1E55451A248EB638B9255039BAE834E7FBBDEAF6F4FBA35774B0C5CCF5400236601D516FD4C09B8F52EAD42C0C3A65A286E1154D02AD97AEBC311076DB35B0DF10777A074AEBB4FAB1ECD097C934DBE5DA2A0F47A4227275C35555EA1E46E9F381A0FA83709750A69498E8A665BA1D52";
    var random = "669741F2BF08636D5157"
    var getSentRandom = await this.hcrService.VisionApi.GetVPNGetRandomXAndSignX('3', '25');
    if (getSentRandom?.Data) {
      signStr = getSentRandom.Data.SignX
      random = getSentRandom.Data.RandomX;
    }
    var ret = { signStr, random }
    return ret;
  }

  async generatePharUploadeForPres(qrcodedata: string, data: any = null) {
    console.log("gg", qrcodedata);
    const qrdata = JSON.parse(qrcodedata);
    const { C, S, D1 } = qrdata;
    const downloadUrl = `https://10.241.176.234/DownLoadCert?CertNo=${C}`;
    console.log('downloadUrl', downloadUrl);
    console.log('C', C);
    console.log('S', S);  // (3.24)前32位
    console.log('D1', D1);

    if (data == null) {
      data = {
        hospid: !NullOrEmptyTrim(UserCache.getLoginUser().Clinic.NHICode) ? UserCache.getLoginUser().Clinic.NHICode : '',
        samId: "001000005284",
        patientCId: 'Z299999992', // pres.patientCId, U121620751 測試用 Z299999992
        ItreatnumOri: '81SAN0U11M0AFJ2GQPAC', // 原就醫識別碼
        OriDate: '20250924', //  DateHelper.getFullDateString(wholeHist.WholeHist.Register.RegDate)
        RecipeType: 'A', // A- 一般處方箋 B- 慢性病處方箋 C- 慢性病連續處方箋
        RecipeTimes: '1', // 當次調劑次數 A、B 者請填 1、C 者 1：第一聯 2：第二聯 3：第三聯
        RegDate: '', // 調劑日期 非必填
      };
    }

    var aesKey = 'ODN20F7WUIS6NUS1DBZUR8KQLSNCGRT4';
    var newaesKey = await this.SearchKey(data.hospid, data.samId);
    aesKey = !NullOrEmptyTrim(newaesKey) ? newaesKey : aesKey;
    console.log('key:', aesKey);

    var ret0 = await this.histApi.CreateERxData(downloadUrl, S, D1, aesKey);
    var data1 = {
      patientCId: ret0.PatientCId, // pres.patientCId, U121620751 測試用 Z299999992
      ItreatnumOri: ret0.ItreatnumOri, // 原就醫識別碼
      OriDate: DateHelper.getFullDateString(ret0.RegDate), //OriDate
      RecipeType: ret0.RecipeType, // A- 一般處方箋 B- 慢性病處方箋 C- 慢性病連續處方箋
      RecipeTimes: ret0.RecipeTimes, // 當次調劑次數 A、B 者請填 1、C 者 1：第一聯 2：第二聯 3：第三聯
      RegDate: DateHelper.getFullDateString(ret0.RegDate),
      AllData: JSON.parse(ret0.AllData),
    }
    this.lastERxData = data1;
    console.log("qrcode", data1);
    console.log("qrcode掃出來的處方", data1.AllData);

    let prescriptionMessage = `請複製以下內容提供給健保署，vpn輸入完畢且驗證通過以後，再關閉此視窗：\nA6: ${data1.AllData.A6}\nA18: ${data1.AllData.A18}\nA26: ${data1.AllData.A26}`;
    let ac = await this.userConfirmService.showConfirm({
      title: '處方資訊',
      msg: prescriptionMessage,
      width: 400,
      textNo: '取消',
      textYes: '繼續上傳'
    });
    if (!ac) return; // 認後才繼續往下走


    var sign = await this.GetPharSendSign();

    var obj = {
      "sHospId": data.hospid,
      "sClientRandom": sign?.random,
      "sSignature": sign?.signStr,
      "sSamId": data.samId,
      "sPatId": data1.patientCId,
      "sTreatNum": data1.ItreatnumOri,
      "sTreatD": data1.OriDate,
      "sRecipeType": data1.RecipeType,
      "sRecipeTimes": data1.RecipeTimes,
      "sRelDate": data1.RegDate,
      "sQRSignature": Array(400).fill('0').map(x => '0').join(''),
      "sType": "1",
    }
    console.log('generatePharUploadeForPres', JSON.stringify(obj), obj);
    var ret = await this.hcrService.SendFromUrl('https://medws.nhi.gov.tw/api/irie3000/UpRecipeStatus',
      JSON.stringify(obj), 'application/json', '', {}
    )
    console.log('ret', ret);
    return ret;
  }

  async queryUploadeForPres(sRecvSeqNo: string) {
    var hospid = !NullOrEmptyTrim(UserCache.getLoginUser().Clinic.NHICode) ? UserCache.getLoginUser().Clinic.NHICode : '';
    var obj = {
      "sHospId": hospid,
      "sClientRandom": "00000000000000000000",
      "sSignature": "12345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567889012345678901234567890123456789012345678901",
      "sSamId": "000000000000",
      "sub":
        [{ "sRecvSeqNo": `${sRecvSeqNo}` }
        ]
    }
    var ret = await this.hcrService.SendFromUrl('https://medws.nhi.gov.tw/api/irie2200/QryRecipeChkRes',
      JSON.stringify(obj), 'application/json', '', {}
    )
    return ret;
  }
  async generateUploadeForPres(regId: number) {
    // var request = new HCASignRequestData();
    // request.InitModule = repeatprehcaModule?.InitModule;
    // request.InitSession = repeatprehcaModule?.InitSession;
    //  let sign = await this.hcrService.VisionApi.GetHCASign(request);
    // let signStr = sign?.Data;
    let signStr = "2597D7E5CBEA5A92C5C35442FA89312131022746093A00A8ECC7FC1F5B42CB49DE8DEBD22840FC409A314FC33AD35BA0776A00D2C51F8DAE515D290F826F0533D2A721C335DBF3BEE318971A68A857ECFFE1BC816C56904826CFE6E80234C5AFD0E95B4064A976554466A738A2E6CF6D335600A48D89BA240F177DCD5E7D1A9655AF214A25A1A8B9715EAAF328E524BA1E55451A248EB638B9255039BAE834E7FBBDEAF6F4FBA35774B0C5CCF5400236601D516FD4C09B8F52EAD42C0C3A65A286E1154D02AD97AEBC311076DB35B0DF10777A074AEBB4FAB1ECD097C934DBE5DA2A0F47A4227275C35555EA1E46E9F381A0FA83709750A69498E8A665BA1D52";
    var random = "669741F2BF08636D5157"
    let signKey = '';
    let randomKey = '';
    var samId = "001000005284";
    var aesKey = 'ODN20F7WUIS6NUS1DBZUR8KQLSNCGRT4';
    var samNodData = await this.hcrService.VisionApi.GetCardNoSAM()
    if (samNodData?.Data) {
      console.log('samNodData', samNodData);
      samId = samNodData.Data;
    }
    var getSentRandom = await this.hcrService.VisionApi.GetVPNGetRandomXAndSignX('3', '24');
    if (getSentRandom?.Data) {
      signStr = getSentRandom.Data.SignX
      random = getSentRandom.Data.RandomX;
    }
    var getKeyRandom = await this.hcrService.VisionApi.GetVPNGetRandomXAndSignX('3', '26');
    if (getKeyRandom?.Data) {
      signKey = getKeyRandom.Data.SignX
      randomKey = getKeyRandom.Data.RandomX;
    }

    let clinic = UserCache.getLoginUser().Clinic;
    const hospIdFromSAM = (await this.hcrService.VisionApi.GetHospID()).Data;
    if (hospIdFromSAM) {
      clinic.NHICode = hospIdFromSAM;
    }
    let userCId = UserCache.getLoginUser().CId;
    let userName = UserCache.getLoginUser().Name;
    // 健保署的規格詭異，產QRCode的處方箋內容時就要做Brotli壓縮，上傳則是在產生CSD時才壓縮
    let wholeHist = await this.histApi.getRepeatedPrescription(regId, signStr, clinic, userCId, userName, true, false);
   
    let doctorICSqno = await this.GetHCACert();

    var date = new Date();
    var pres = new IC6_0PresQRCodeBundle();
    var hrx = wholeHist.WholeHist.Hist.HRxs.find(x => x.RxType == 2);
    if (!hrx) hrx = wholeHist.WholeHist.Hist.HRxs.find(x => x.RxType == 3 || x.RxType == 4);
    pres.Isqno = wholeHist.WholeHist.Register.Icno;
    pres.Itreatnum = wholeHist.NHIRegIC.Itreatnum;
    pres.MainDisease = wholeHist.WholeHist.Hist.Dx1;
    pres.patientName = wholeHist.WholeHist.Patient.CName;
    pres.MainDiseaseDesc = wholeHist.WholeHist.Hist.Dx1Name;
    pres.clinicAddress = !NullOrEmptyTrim(UserCache.getLoginUser().Clinic.Address) ? UserCache.getLoginUser().Clinic.Address : 'TEST';
    pres.clinicPhone = !NullOrEmptyTrim(UserCache.getLoginUser().Clinic.Phone) ? UserCache.getLoginUser().Clinic.Phone : pres.clinicPhone;
    pres.clinicCode = !NullOrEmptyTrim(clinic.NHICode) ? clinic.NHICode : '';
    pres.clinicName = UserCache.getLoginUser().Clinic.Name;
    pres.createDate = DateHelper.formatDateToPlusOne(date, 1);
    pres.doctorName = wholeHist.WholeHist.Register.DoctorName;
    pres.histCase = wholeHist.WholeHist.Hist.Case;
    pres.histCaseDesc = pres.histCase == '01' ? '西醫一般案件' : '西醫其他專案';
    pres.patientBirthDate = DateHelper.getFormatedDateString(wholeHist.WholeHist.Patient.Birthday, false, '-');
    pres.patientGender = wholeHist.WholeHist.Patient.Sex == 0 ? 'female' : 'male';
    pres.patientMedicalRecordNumber = 'Med000001';
    pres.patientName = wholeHist.WholeHist.Patient.CName;
    pres.patientCId = wholeHist.WholeHist.Patient.CId;
    pres.MedDays = wholeHist.WholeHist.Hist.Days;
    pres.createDate = DateHelper.formatDateToPlusOne(date, 1);
    pres.DayStart = DateHelper.formatDateToPlusOne(date, 8);
    pres.DayEnd = pres.ddDaysKeepOffset(pres.DayStart, 2);
    pres.PillDays = hrx.InfoDays;
    pres.PillTotal = hrx.TotalDose != null ? hrx.TotalDose.toFixed(2) : '0.00';

    if (!NullOrEmptyTrim(signKey) && !NullOrEmptyTrim(randomKey)) {
      var queryObj = {
        "sHospId": pres.clinicCode,
        "sClientRandom": randomKey,
        "sSignature": signKey,
        "sSamId": samId,
      }

      var retQuery = await this.hcrService.SendFromUrl('https://medws.nhi.gov.tw/api/irie4000/QryFileKeyValue',
        JSON.stringify(queryObj), 'application/json', '', {}
      )
      console.log('retQuery:', retQuery);

      if (retQuery.Successed && retQuery.Returns) {
        var returnsObj = JSON.parse(retQuery.Returns);
        aesKey = returnsObj?.sKey || aesKey;
      }
    }
    console.log('key:', aesKey);
    var a: string = pres.getbundleTemplate();
    const encoded = this.base64EncodeUTF8(a);
    console.log('a =>', a, 'a =>', encoded);
    var shortSign = signStr.slice(0, 32); // 只取前32字元 (給健保署專案驗證時S欄位只取前32字元，請前線手動擷取)
    var prescriptData = await this.histApi.GetRepeatedPrescriptSignAndData(shortSign, wholeHist.Data, doctorICSqno, aesKey, true);   // 上傳或現在驗證都要在這邊壓縮
    this.fileService.downloadAs(prescriptData.SignData, '處方箋CSD1.json');


    var qrcode = btoa(prescriptData.SignData);
    // var qrcode2 = "";
    var qOtherData: string[] = [];
    if (prescriptData?.Data[0]?.length > 0) {
      for (var i = 0; i < prescriptData.Data.length - 1; i++) {
        var dSeq = 'D' + (i + 2).toString();
        var q = '{\"' + dSeq + '\": \"' + prescriptData?.Data[i] + '\"}';
        var q2json = JSON.stringify(q)
        qOtherData.push(btoa(q2json));
      }
      // var q2 = {
      //   "D2":prescriptData?.Data[0]
      // }
      // var q2json =  JSON.stringify(q2)
      // qrcode2 = btoa(q2json)
    }
    var obj = {
      "sHospId": pres.clinicCode,
      "sClientRandom": random,
      "sSignature": signStr,
      "sSamId": samId,
      "sPatId": pres.patientCId,
      "sTreatNum": wholeHist.NHIRegIC.Itreatnum,
      "sTreatD": DateHelper.getFullDateString(wholeHist.WholeHist.Register.RegDate),
      "sChrSeqNo": "1",
      "sRecipeType": "A",
      "sQRSignature": Array(400).fill('0').map(x => '0').join(''),
      "sType": "1",
      "sRecipeData": encoded,
      "sQRCodeData": qrcode,
      "sQRCodeData2": qOtherData[0] ?? "",   //qrcode2,
      "sQRCodeData3": qOtherData[1] ?? ""
    }
    console.log('JSON.stringifyobj', JSON.stringify(obj), obj);
    var ret = await this.hcrService.SendFromUrl('https://medws.nhi.gov.tw/api/irie2000/UpLoadRecipeData',
      JSON.stringify(obj), 'application/json', '', {}
    )
    console.log('ret', ret);
    return ret;
  }
  base64EncodeUTF8(str: string): string {
    return btoa(unescape(encodeURIComponent(str)));
  }
  /**
   * 產生掛號 J複製(StatusCode='J')存檔後靜默列印的單據清單。
   * 每項單據的最終值為 REG001 的 IsJPrint* AND 本次病歷的醫令條件。
   */
  async setHistPrintParameter(histData: Hist): Promise<PrintResult> {
    var result = new PrintResult();
    var reg001 = await this.clinicData.getParam("REG001");
    result.IsPrintCtrDrugs = reg001.IsJPrintCtrDrugs;
    result.IsPrintDetail = reg001.IsJPrintDetail;
    result.IsPrintDispExam = reg001.IsJPrintDispExam;
    result.IsPrintDispPrescription = reg001.IsJPrintDispPrescription;
    result.IsPrintDrugBag = reg001.IsJPrintDrugBag;
    result.IsPrintExam = false;
    result.IsPrintWay = reg001.IsJPrintWay;
    result.IsPrintPrescription = reg001.IsJPrintPrescription;
    result.IsPrintInjectForm = reg001.IsJPrintInjectForm;
    var canprintDisp = histData.HRxs.some(x => x.RxType == 2 || x.RxType == 3 || x.RxType == 4 || x.RxType == 12);
    var isHavingInjRx = histData.HRxs.filter(x => x.RxType === 4).length > 0;
    var prn001 = await this.clinicData.getParam("PRN001");
    var ctrDrugLevs: string[] = [];

    if (prn001.CTRDrugPrintType?.length > 0) {
      var types = prn001.CTRDrugPrintType;
      if (types.includes('1')) {
        ctrDrugLevs.push('A');
      }
      if (types.includes('2')) {
        ctrDrugLevs.push('B');
      }
      if (types.includes('3')) {
        ctrDrugLevs.push('C');
      }
      if (types.includes('4')) {
        ctrDrugLevs.push('D');
      }
    }
    var isUseCTRDrugs = histData.HRxs.some(x => ctrDrugLevs.includes(x.Rx?.CTRDrugs));
    result.IsPrintCtrDrugs = isUseCTRDrugs && result.IsPrintCtrDrugs;
    // debugger
    //result.IsPrintDispExam = this.hasExam && result.IsPrintDispExam && histData.HRxs.some(x => (x.RxType == 6 || x.RxType == 7) && (x.SPRule != OrderSpecialRuleEnum.A5_ApplyNotPrint && x.SPRule != OrderSpecialRuleEnum.A4_FreeNotPrint)) && !histData.HRxs.filter(x => (x.RxType == 6 || x.RxType == 7)).every(x => x.SPRule == 5);
    // 有要列印的檢驗醫令， ** x.DispTP !== OrderDispensingTypeEnum.T0_Clinic 代表診所委外檢驗
    const needToPrintDispExamOrders = histData.HRxs.some(
      x => ((x.RxType === 6 || x.RxType === 7) && x.DispTP !== OrderDispensingTypeEnum.T0_Clinic) &&
        (x.SPRule !== OrderSpecialRuleEnum.A5_ApplyNotPrint && x.SPRule !== OrderSpecialRuleEnum.A4_FreeNotPrint)
    );
    // 所有的檢驗醫令都是不列印的才為 false，只要有一個要列印就為 true
    const notNeedPrintExamOrdersHaveSPRule5Or4 = !histData.HRxs.filter(
      x => (x.RxType === 6 || x.RxType === 7) && x.DispTP !== OrderDispensingTypeEnum.T0_Clinic)
      .every(x => x.SPRule === OrderSpecialRuleEnum.A5_ApplyNotPrint || x.SPRule === OrderSpecialRuleEnum.A4_FreeNotPrint);
    // hasExam: true 代表有檢驗醫令
    // IsPrintDispExam: true 代表參數設定要列印交付檢驗醫令
    const sencondAdPh = histData.HRxs.some(
      x => (['23', '24', '26', '28'].indexOf(x.Rx?.StdCode) >= 0) || (['23', '24', '26', '28'].indexOf(x.StdCode) >= 0)
    )
    result.IsPrintDispExam = !sencondAdPh && result.IsPrintDispExam && needToPrintDispExamOrders && notNeedPrintExamOrdersHaveSPRule5Or4;
    result.IsPrintDispPrescription = (histData.CntPresNo == '1'
      || (canprintDisp
        && !(histData.HRxs.filter(x => x.RxType == 2 || x.RxType == 3 || x.RxType == 4 || x.RxType == 12)
          .every(x => x.SPRule == OrderSpecialRuleEnum.A5_ApplyNotPrint
            || x.SPRule == OrderSpecialRuleEnum.A4_FreeNotPrint
            || x.SPRule == OrderSpecialRuleEnum.A3_FreeAndPrint
            || x.DispTP == OrderDispensingTypeEnum.T0_Clinic
          ))
        && result.IsPrintDispPrescription));
    // ));
    result.IsPrintExam = false;
    result.IsPrintDrugBag = result.IsPrintDrugBag && histData.DispTP != DispensingTypeEnum.NoNeed;

    result.IsPrintInjectForm = result.IsPrintInjectForm && isHavingInjRx ? true : false;
    return result;
  }

  generateM56(nhictp: string, sameTreat: string, clinicType: ClinicTypeEnum, clinicNHIType: MedicalEnum): M56Code | "" {
    let way = "";
    const stayMedArr = ["05", "BA", "BE", "BF", "BG", "DC"]; // 住院專用
    if (stayMedArr.includes(nhictp)) way = "StayMed";
    if (way !== "StayMed" && sameTreat === "0") return M56Code.DialysisClinic; // "15"

    let typestr: M56Code | "" = "";

    switch (clinicType) {
      case ClinicTypeEnum.DentistClinic:
      case ClinicTypeEnum.WesternAndDentistClinic:
        typestr = M56Code.DentistClinic; // "13"
        break;

      case ClinicTypeEnum.ChineseClinic:
        typestr = M56Code.ChineseClinic; // "14"
        break;

      case ClinicTypeEnum.Other:
      case ClinicTypeEnum.HomeCare:
      case ClinicTypeEnum.LongTermCare:
      case ClinicTypeEnum.MedicalBeauty:
      case ClinicTypeEnum.PostpartumCare:
      case ClinicTypeEnum.DayCare:
      case ClinicTypeEnum.Company:
        typestr = way !== "StayMed" ? M56Code.OtherOutpatient : M56Code.StayOther;
        break;

      case ClinicTypeEnum.Drugstore:
        typestr = M56Code.Drugstore;
        break;

      default:
        typestr = "";
        break;
    }

    if (typestr !== "") return typestr;

    switch (clinicNHIType) {
      case MedicalEnum.MedicalCenter:
      case MedicalEnum.RegionalHospital:
      case MedicalEnum.DistrictHospital:
        return way === "StayMed" ? M56Code.StayWesternHospital : M56Code.WesternHospital;

      case MedicalEnum.PrimaryClinic:
        return way === "StayMed" ? M56Code.StayWesternClinic : M56Code.WesternClinic;

      case MedicalEnum.PhysicalTherapy:
        return M56Code.PhysicalTherapy;

      case MedicalEnum.Inspection:
        return M56Code.InspectionClinic;

      case MedicalEnum.DrugStore:
        return M56Code.Drugstore;

      case MedicalEnum.RecoveryHome:
      case MedicalEnum.HomeCare:
      case MedicalEnum.UnknownClinic:
      case MedicalEnum.Radiation:
        return way === "StayMed" ? M56Code.StayOther : M56Code.OtherOutpatient;

      default:
        return "";
    }
  }
  
  public lastERxData: any = null;
  async GetHCACert(): Promise<string> {
    var hcaCertData = this.sessionService.getData('doctorPinCode');
    return hcaCertData?.Cert || '';
  }
  async ParseHCACertNum(pem: string): Promise<string> {
    // 1. 解析憑證
    if (NullOrEmptyTrim(pem)) return '';
    const cert = forge.pki.certificateFromPem(pem);
    this.debugNotify.Notify('解析憑證:' + JSON.stringify(cert))
    // 2. 取得序號（十六進位字串）
    return cert?.serialNumber.toUpperCase() ?? '';
  }
  async ParseHCACertNumTS(pem1: string): Promise<string> {
    if (!pem1?.trim()) return '';
    const pem = `-----BEGIN CERTIFICATE-----${pem1}-----END CERTIFICATE-----`;

    try {
      const cert = forge.pki.certificateFromPem(pem);
      console.log('憑證內容:', pem);
      return cert.serialNumber?.toUpperCase() ?? '';
    } catch (err) {
      console.log('解析憑證失敗:', err);
      console.error('解析憑證失敗:', err);
      return '';
    }
  }
}
